/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
/* eslint-disable no-await-in-loop */
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';
import { Buffer } from 'buffer';
import PlatformUtils, { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import ini from 'ini';
import saveAs from 'file-saver';
import {
    addToConsole,
    setConsole,
    setSelectedNetwork,
    debuggerInit,
    debuggerDeviceBuzz,
    debuggerDeviceReboot,
    debuggerRefresh,
    debuggerDevicePause,
    debuggerVariablesGetAll,
    debuggerVariableGet,
    debuggerVariableSet,
    debuggerStop,
    debuggerDeviceRestartDebug,
    debuggerDeviceLogin,
    debuggerSetPassword,
    debuggerUploadApplication,
    debuggerUploadFirmware,
    debuggerDeviceStartDebug,
    debuggerSetBinary,
    debuggerTaskStop,
    debuggerDownloadRelease,
    debuggerDownloadTcu,
    debuggerSaveTcu,
    debuggerDownloadTcuFromServer,
    debuggerUploadRelease,
    debuggerClose,
    debuggerSaveFirmware,
    deviceDashboardProxyHttpRequest,
    toggleBlockBreakpoint,
    debuggerAttachSerial,
    debuggerDetachSerial,
    setGPIOState,
    sendWiegand,
    simulatorSendEvent,
    debuggerDeviceStepOver,
} from '@appblocks/frontend/redux/debugSlice';
import TOBJ from '@appblocks/debug/TOBJ';
import { generateId, indirectEval } from '@appblocks/utils';
import {
    axiosInstance,
    floatToBytes,
    parseFloat,
    toHexString,
    makeid,
    base64ToBin,
    binToBase64,
} from '@appblocks/frontend/client/utils';
import { bootromB1 } from '@appblocks/frontend/client/boards/RP2040BootRom';
import { loadUF2 } from '@appblocks/frontend/client/boards/RP2040LoadFlash';
// import {
//     avrInstruction,
//     AVRTimer,
//     CPU,
//     timer0Config,
//     AVRIOPort,
//     portBConfig,
//     portCConfig,
//     portDConfig
// } from "avr8js";
import {
    PCODE_STATE_ERROR,
    PCODE_STATE_STOPPED,
    PCODE_STATE_PAUSED,
    PCODE_STATE_RUN,
    PCODE_STATE_DEBUG_PRINT_AND_CONTINUE,
    PCODE_STATE_DEBUG_PRINT_AND_STOP,
    PCODE_STATE_HALT,
    PCODE_STATE_STACK_OVERFLOW,
    PCODE_STATE_OOR,
    PCODE_STATE_DIVIDE_BY_ZERO,
    PCODE_STATE_ILLEGAL_OPCODE,
} from '@appblocks/frontend/redux/constants';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    TOBJDataType, TOBJVariableEntry, ProjectCompileError, HTTPMessage, TibboDeviceState, PCODEMachineState,
} from '@appblocks/codegeneration/types';
import { setProjectCode, projectSetBinaryId } from '@appblocks/frontend/redux/projectSlice';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectInstance from '@appblocks/frontend/client/ProjectInstance';
import { MicropythonSerial } from '@tibbo/tide-proxy/MicropythonSerial';
// import SerialPort from '@appblocks/frontend/client/micropython/BrowserSerialPort';
import SerialPort from '@tibbo/tide-proxy/BrowserSerialPort';
// import * as ESP32Serial from '@appblocks/frontend/client/esp32/serial';
import { BrowserESP32Serial } from '@tibbo/tide-proxy/ESP32Serial';
import posthog from 'posthog-js';
import {
    Transport,
} from 'esptool-js/lib/index.js';
import axios, { CancelTokenSource } from 'axios';


const { Subject } = require('await-notify');
const md5 = require('js-md5');

const debugMiddleware = createListenerMiddleware();

let store: any;

let debuggerInstance: Debugger;

const REPLY_OK = 'A';
const REPLY_DENIED = 'D';

enum TOBJ_DATA_TYPES {
    TOBJ_TYPE_UNKNOWN = 0,
    TOBJ_TYPE_BOOLEAN = 1,
    TOBJ_TYPE_BYTE = 2,
    TOBJ_TYPE_CHAR = 3,
    TOBJ_TYPE_WORD = 4,
    TOBJ_TYPE_SHORT = 5,
    TOBJ_TYPE_DWORD = 6,
    TOBJ_TYPE_LONG = 7,
    TOBJ_TYPE_REAL = 8,
    TOBJ_TYPE_STRING = 9,
    TOBJ_TYPE_ENUM = 10,
    TOBJ_TYPE_ARRAY = 11,
    TOBJ_TYPE_STRUCT = 12,
    TOBJ_TYPE_VOID = 13,
    TOBJ_TYPE_BITFIELD = 14,
    TOBJ_TYPE_POINTER = 15,
    TOBJ_TYPE_REFERENCE = 16,
    TOBJ_TYPE_ARRAY_C = 17,
    TOBJ_TYPE_STRUCT_C = 18,
    TOBJ_TYPE_UNION = 19,
}

enum PCODE_COMMANDS {
    STATE = 'PC',
    RUN = 'PR',
    PAUSE = 'PB',
    BREAKPOINT = 'CB',
    GET_MEMORY = 'GM',
    GET_PROPERTY = 'GP',
    SET_PROPERTY = 'SR',
    SET_MEMORY = 'SM',
    STEP = 'PO',
    SET_POINTER = 'SP',
    DISCOVER = '_?',
    INFO = 'X',
    RESET_PROGRAMMING = 'Q',
    RESET_PROGRAMMING_REBOOT = 'QF',
    UPLOAD = 'D',
    APPUPLOADFINISH = 'T',
    BUZZ = 'B',
    REBOOT = 'EC',
    REQUEST_LOGIN = 'Y',
    LOGIN = 'L',
    SET_PASSWORD = 'K',
}

enum DEBUG_STATE {
    EMPTY = '',
    DEBUG = 'DEBUG',
    PASSWORD_REQUIRED = 'PASSWORD_REQUIRED',
    PAUSED = 'PAUSED',
    SEARCHING = 'SEARCHING',
    BUILDING = 'BUILDING',
    STARTING = 'STARTING',
    UPLOADING = 'UPLOADING',
    LOGIN = 'LOGIN',
}

enum FIRMWARE_UPLOAD_STATE {
    EMPTY = '',
    SAVING = 'SAVING',
    SAVED = 'SAVED',
    ERROR = 'ERROR',
}

enum DebuggerTaskType {
    GENERATE_CODE = 'generate_code',
    COMPILE = 'compile',
    UPLOAD_FIRMWARE = 'upload_firmware',
    UPLOAD_APPLICATION = 'upload_application',
    DEBUG = 'debug',
}

interface DebuggerTask {
    id: string;
    type: DebuggerTaskType;
    data: any;
}

interface DebuggerCompileResult {
    symbols: Buffer;
    binary: Buffer;
    hex: Buffer;
    output: string;
}

const COMMAND_WAIT_TIME = 10000;
const READ_BLOCK_SIZE = 16;

class Debugger {
    // eslint-disable-next-line react/sort-comp

    messages: any;

    pcodestate: any;

    getDeviceQuery: any;

    deviceResetQuery: any;

    loginRequest: any;

    getDeviceInfo: any;

    devices: any;

    pdb: Buffer | undefined;

    tpc: Buffer | undefined;

    tpr: any;

    socket: any;

    lastReplyTimestamp: number;

    tobj: TOBJ | undefined;

    project: ProjectConfiguration | undefined;

    memoryCalls: any;

    debugFiles: any[];

    deviceStateTimer: any;

    debugging: boolean;

    lastUpdateTime: Date;

    projectUpdatedAt: Date;

    memorySet: any;

    pauseDevice: any;

    user: any;

    uploadType: string;

    tasks: DebuggerTask[];

    lastResponseTime: Date;

    files: any;

    worker: any;

    currentDeviceState: TibboDeviceState;

    debugStarted: boolean;

    serialOutputTimer: any;

    device: any;

    simulator: any;

    codeRequestCancelTokenSource: CancelTokenSource | null;

    constructor() {
        this.pcodestate = new Subject();
        this.getDeviceQuery = new Subject();
        this.loginRequest = new Subject();
        this.getDeviceInfo = new Subject();
        this.deviceResetQuery = new Subject();
        this.tasks = [];

        this.handleBuzz = this.handleBuzz.bind(this);
        this.handleReboot = this.handleReboot.bind(this);
        this.handleDebug = this.handleDebug.bind(this);
        this.sendRun = this.sendRun.bind(this);
        this.sendPause = this.sendPause.bind(this);
        this.sendStop = this.sendStop.bind(this);
        this.socketEmit = this.socketEmit.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleFirmwareUpload = this.handleFirmwareUpload.bind(this);
        this.getDeviceState = this.getDeviceState.bind(this);

        this.devices = [];
        this.socket = undefined;
        this.pdb = undefined;
        this.lastReplyTimestamp = 0;
        this.tobj = undefined;
        this.project = undefined;
        this.debugFiles = []; // this is the current files being debugged
        this.memoryCalls = [];
        this.debugging = false;
        this.memorySet = new Subject();
        this.worker = new Worker(new URL('./worker.js', import.meta.url));
        this.worker.onmessage = this.getDeviceState;
        this.debugStarted = false;
        this.codeRequestCancelTokenSource = null;
    }

    setNetwork(networkId: string) {
        if (networkId === 'localhost') {
            this.connect(undefined, networkId);
        } else {
            this.connect(this.user, networkId);
        }
    }

    connect(user: any, networkId: string) {
        if (this.socket) {
            this.disconnect();
        }
        let socketURL = `${process.env.API_URL}/tide`;
        let options = {};
        if (user === undefined) {
            const EDITOR_PROXY_URL = process.env.EDITOR_PROXY_URL || 'http://localhost:3535';
            socketURL = `${EDITOR_PROXY_URL}/tide`;
        } else {
            this.user = user;
            options = {
                path: `/tide/client/${networkId}`,
                withCredentials: true,
                // transports: ['polling'],
            };
        }
        const socket = io(socketURL, options);

        socket.on('connect_error', (err) => {
            // console.log(`connect_error due to ${err.message}`);
            store.dispatch({
                type: 'debug/setConnected',
                payload: false,
            });
        });

        socket.on('device', async (device) => {
            const debug = store.getState().debug;
            const currentDevice = debug.device;
            if (device.streamURL) {
                // this is a remote device
                try {
                    const response = await axiosInstance.get(`${process.env.API_URL}/tide/client/remotedevices/${device.mac}`);
                    const data = response.data;
                    device.userId = data.userId;
                    if (data.nextAvailability) {
                        device.nextAvailability = data.nextAvailability;
                    } else {
                        device.nextAvailability = 0;
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            store.dispatch({
                type: 'debug/addDevice',
                payload: device,
            });
            if (debug.device && device.mac === debug.device.mac) {
                this.getDeviceQuery.notify();
                store.dispatch({
                    type: 'debug/setDevice',
                    payload: {
                        ...device,
                        state: currentDevice ? currentDevice.state : undefined,
                    },
                });
            }
        });

        socket.on('connect', () => {
            store.dispatch({
                type: 'debug/setConnected',
                payload: true,
            });
            this.refresh();
        });

        socket.on('console', (line) => {
            const { debugState } = store.getState().debug;
            if (debugState !== DEBUG_STATE.BUILDING) {
                store.dispatch({
                    type: 'debug/addToConsole',
                    payload: line,
                });
            }
        });

        // upload progress
        socket.on('upload', (data) => {
            const { device, console } = store.getState().debug;
            if (!device || data.mac !== device.mac) {
                return;
            }
            let task;
            for (let i = 0; i < this.tasks.length; i++) {
                if (this.tasks[i].type === DebuggerTaskType.UPLOAD_APPLICATION
                    || this.tasks[i].type === DebuggerTaskType.UPLOAD_FIRMWARE) {
                    task = this.tasks[i];
                    break;
                }
            }
            if (task === undefined) {
                return;
            }

            const { progress } = store.getState().debug;
            const percentage = Math.round(Number(data.data) * 100);
            if (progress !== percentage) {
                const curTime = new Date();
                if (this.lastUpdateTime === undefined
                    || curTime.getTime() - this.lastUpdateTime.getTime() > 300) {
                    this.lastUpdateTime = curTime;
                    store.dispatch({
                        type: 'debug/setProgress',
                        payload: percentage,
                    });
                    store.dispatch({
                        type: 'messages/updateMessage',
                        payload: {
                            id: task.id,
                            message: {
                                progress: percentage,
                            },
                        },
                    });
                    store.dispatch({
                        type: 'debug/setDebugState',
                        payload: DEBUG_STATE.UPLOADING,
                    });
                }
            }
        });

        socket.on('reply', this.onReply.bind(this));

        socket.on('upload_complete', async (data) => {
            const { device } = store.getState().debug;
            let task;
            if ((!device || data.mac !== device.mac) && data.method === undefined) {
                // ignore tibbo device uploads of irrelevant devices
                return;
            }
            const project = ProjectInstance.getInstance();
            const baudRate = Number(project.getFeature('general').getSettingValue('BAUD'));

            for (let i = 0; i < this.tasks.length; i++) {
                if (this.tasks[i].type === DebuggerTaskType.UPLOAD_APPLICATION
                    || this.tasks[i].type === DebuggerTaskType.UPLOAD_FIRMWARE) {
                    task = this.tasks[i];
                    this.removeTask(task.id);
                }
            }
            store.dispatch({
                type: 'debug/clearConsole',
                payload: '',
            });
            if (!task) {
                return;
            }

            if (device && device.type === 'serial' && task.data.debug) {
                setTimeout(() => {
                    store.dispatch({
                        type: 'debug/debuggerAttachSerial',
                        payload: {
                            baudRate,
                            reset: project.runtime === 'micropython',
                        },
                    });
                }, 100);
            }

            if (task.type === DebuggerTaskType.UPLOAD_FIRMWARE) {
                this.handleReboot(task.data.device);
            }
            this.removeTask(task.id);
            if (this.pdb !== undefined && task.data.debug) {
                this.sendRun();
            }
            if (!task.data.debug) {
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
                this.addDebugMessage('Upload complete', false, 6000);
            }
        });

        socket.on('debug_print', (data) => {
            const { device, console } = store.getState().debug;
            if (!device || data.mac !== device.mac || !this.debugStarted) {
                return;
            }
            let consoleData = JSON.parse(data.data).data;
            if (device.type === 'tios') {
                if (consoleData.indexOf('\r\n') === -1) {
                    consoleData += '\r\n';
                }
                const lines = consoleData.split('\n');
                lines.forEach((tmpLine: string) => {
                    if (tmpLine.trim() === '') {
                        return;
                    }
                    if (tmpLine.indexOf('\r\n') === -1) {
                        tmpLine = `${tmpLine}\r\n`;
                    }
                    store.dispatch({
                        type: 'debug/addToConsole',
                        payload: tmpLine,
                    });
                });
            } else {
                store.dispatch({
                    type: 'debug/addToConsole',
                    payload: consoleData,
                });
            }
        });

        socket.on('http_response', (response) => {
            const {
                data,
                nonce,
                status,
                url,
            } = response;
            store.dispatch({
                type: 'debug/setDeviceDashboardRequests',
                payload: {
                    nonce,
                    response: data,
                },
            });
        });

        socket.on('upload_error', (data) => {
            const { device } = store.getState().debug;
            let task;
            if (data.method === 'tios' && (!device || data.mac !== device.mac)) {
                return;
            }
            for (let i = 0; i < this.tasks.length; i++) {
                if (this.tasks[i].type === DebuggerTaskType.UPLOAD_APPLICATION
                    || this.tasks[i].type === DebuggerTaskType.UPLOAD_FIRMWARE) {
                    task = this.tasks[i];
                    this.removeTask(task.id);
                }
            }

            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
            if (data.code === 'not_found') {
                switch (data.method) {
                    case 'bossac':
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                message: `
Bossa not found. Please install Bossa from the following link and add to your PATH:

<a href="https://github.com/shumatech/BOSSA/releases" target="_blank">https://github.com/shumatech/BOSSA/releases</a>
                            `,
                                title: 'Uploader Not Found',
                                format: 'markdown',
                                cancellable: false,
                            },
                        });
                        break;
                    case 'openocd':
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                message: `
OpenOCD not found. Please install OpenOCD from the following link and add to your PATH:

<a href="https://openocd.org/pages/getting-openocd.html" target="_blank">https://openocd.org/pages/getting-openocd.html</a>
                            `,
                                title: 'Uploader Not Found',
                                format: 'markdown',
                                cancellable: false,
                            },
                        });
                        break;
                    case 'jlink':
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                message: `
JLinkExe not found. Please install J-Link Software from the following link and add to your PATH:

<a href="https://www.segger.com/downloads/jlink/#J-LinkSoftwareAndDocumentationPack" target="_blank">https://www.segger.com/downloads/jlink/</a>
                            `,
                                title: 'Uploader Not Found',
                                format: 'markdown',
                                cancellable: false,
                            },
                        });
                        break;
                    default:

                        break;
                }
                return;
            }
            this.addDebugMessage('Upload failed', false, 6000);
        });

        socket.on('message', (data) => {
            // const { device } = store.getState().debug;
            // if (!device || data.mac !== device.mac) {
            //     return;
            // }
            console.log(data);
            this.addDebugMessage(data.data, false, data.delay);
        });

        socket.on('detach_serial', (data) => {
            const { device, serialPort } = store.getState().debug;
            if (!device || data.mac !== device.mac) {
                return;
            }
            if (serialPort && serialPort.port === device.mac) {
                store.dispatch({
                    type: 'debug/debuggerDetachSerial',
                    payload: '',
                });
            }
        });

        // socket.on('build', (data) => {
        //     const { device, console } = store.getState().debug;
        //     const line = data;
        //     store.dispatch({
        //         type: 'debug/addConsoleLine',
        //         payload: line,
        //     });
        // });
        this.socket = socket;
    }

    disconnect() {
        const { device, debugState, devices } = store.getState().debug;
        if (this.socket) {
            if (debugState !== '') {
                this.sendStop();
            }
            this.socket.removeAllListeners();
            this.socket.disconnect();
        }
        if (this.deviceStateTimer) {
            clearInterval(this.deviceStateTimer);
            this.deviceStateTimer = undefined;
        }

        if (this.serialOutputTimer) {
            clearInterval(this.serialOutputTimer);
            this.serialOutputTimer = undefined;
        }
    }

    setBreakpoints() {
        const { device, debugState } = store.getState().debug;
        const breakpoints = this.getBreakpoints();
        if (debugState === '' || debugState === DEBUG_STATE.PAUSED || !device) {
            return;
        }
        this.sendPCommand(device.mac, PCODE_COMMANDS.BREAKPOINT, breakpoints);
    }

    setGPIOState(address: string, pin: number, state: number) {
        this.socketEmit('gpio_set', {
            value: state,
            address,
            pin,
        });
    }

    sendWiegand(address: string, value: number) {
        this.socketEmit('wiegand_send', {
            address,
            value,
        });
    }

    sendPCommand(mac: string, command: string, data = '') {
        const { device, debugState, devices } = store.getState().debug;
        if (!device) {
            return;
        }
        const nonce = makeid(8);
        const message = {
            command,
            mac,
            data,
            nonce,
        };
        this.socketEmit('command', message);
        // console.debug(`SEND:${JSON.stringify(message)}`);
    }

    async onReply(message: any) {
        const { device, debugState, devices } = store.getState().debug;
        if (!device || message.mac !== device.mac) {
            return;
        }
        // console.debug(`RECV:${JSON.stringify(message)}`);
        const prevState = device.pcode.toString().substring(0, 3);
        switch (message.replyFor) {
            case PCODE_COMMANDS.RUN:
            case PCODE_COMMANDS.STATE:
                {
                    if (!this.debugging || !message.data) {
                        return;
                    }
                    const parts = message.data.split(' ')[1].split(',');
                    const currentDeviceState: TibboDeviceState = {
                        state: message.data.substring(0, 3),
                        registerA: parseInt(parts[0].substring(2), 16),
                        registerB: parseInt(parts[1].substring(2), 16),
                        pcodeCounter: parseInt(parts[2].substring(3), 16),
                        stackPointer: parseInt(parts[3].substring(3), 16),
                        flags: parts[4].substring(2),
                    };
                    this.currentDeviceState = currentDeviceState;
                    this.lastReplyTimestamp = new Date().getTime();
                    this.pcodestate.notify();
                    const deviceState = message.data;
                    const newDeviceState = {
                        ...device,
                        state: deviceState,
                    };
                    const pcodeState = deviceState.toString().substring(0, 3);
                    store.dispatch({
                        type: 'debug/setDevice',
                        payload: newDeviceState,
                    });
                    switch (pcodeState) {
                        case PCODE_STATE_RUN:
                            if (this.debugging) {
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.DEBUG,
                                });
                            }
                            break;
                        case PCODE_STATE_ERROR:
                            store.dispatch({
                                type: 'debug/setDebugState',
                                payload: DEBUG_STATE.EMPTY,
                            });
                            return;
                        case PCODE_STATE_STOPPED:
                            if (!this.debugging) {
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.EMPTY,
                                });
                            } else {
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.PAUSED,
                                });
                            }
                            return;
                        case PCODE_STATE_PAUSED:
                        case PCODE_STATE_DEBUG_PRINT_AND_STOP:
                            {
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.PAUSED,
                                });
                                if (device.state === deviceState
                                    || debugState === DEBUG_STATE.EMPTY) {
                                    return;
                                }
                                const reason = deviceState.toString().substring(4, 6);
                                switch (reason) {
                                    case PCODE_STATE_HALT:
                                        this.addDebugMessage('System Halted', false, 3000);
                                        break;
                                    case PCODE_STATE_STACK_OVERFLOW:
                                        this.addDebugMessage('Stack Overflow', false, 3000);
                                        break;
                                    case PCODE_STATE_OOR:
                                        this.addDebugMessage('Out of Range', false, 3000);
                                        break;
                                    case PCODE_STATE_DIVIDE_BY_ZERO:
                                        this.addDebugMessage('Divide by Zero', false, 3000);
                                        break;
                                    case PCODE_STATE_ILLEGAL_OPCODE:
                                        this.addDebugMessage('Illegal Opcode', false, 3000);
                                        break;
                                    default:
                                        // breakpoint
                                        await this.getStack();
                                        await this.getVariables();
                                        break;
                                }
                            }
                            break;
                        default:

                            break;
                    }
                    if (debugState !== DEBUG_STATE.DEBUG) {
                        store.dispatch({
                            type: 'debug/setDevice',
                            payload: newDeviceState,
                        });
                    } else if (prevState !== deviceState.substring(0, 3)) {
                        store.dispatch({
                            type: 'debug/setDevice',
                            payload: newDeviceState,
                        });
                    }
                }
                break;
            case PCODE_COMMANDS.INFO:
                this.getDeviceInfo.message = message.data;
                this.getDeviceInfo.notify();
                break;
            case PCODE_COMMANDS.LOGIN:
                if (message.reply !== 'A') {
                    store.dispatch({
                        type: 'debug/setDebugState',
                        payload: DEBUG_STATE.PASSWORD_REQUIRED,
                    });
                } else {
                    this.loginRequest.message = message.reply;
                    this.loginRequest.notify();
                }
                break;
            case PCODE_COMMANDS.RESET_PROGRAMMING_REBOOT:
            case PCODE_COMMANDS.RESET_PROGRAMMING:
                this.deviceResetQuery.message = message.reply;
                this.deviceResetQuery.notify();
                if (message.reply !== 'A') {
                    store.dispatch({
                        type: 'debug/setDebugState',
                        payload: DEBUG_STATE.PASSWORD_REQUIRED,
                    });
                }
                break;
            case PCODE_COMMANDS.SET_POINTER:

                break;
            case PCODE_COMMANDS.GET_MEMORY:
                {
                    // **B/01/&h0000001C: 2A
                    const start = message.data.indexOf(':') - 4;
                    const address = message.data.substring(start, start + 4).toLowerCase();
                    const value = message.data.split(' ')[1];

                    // this.tmpMemoryValue = [];
                    // let parts = value.split(',');
                    // for (let i = 0; i < parts.length; i++) {
                    // this.tmpMemoryValue.push(parts[i]);
                    // }
                    if (this.memoryCalls[address] !== undefined) {
                        if (value !== undefined) {
                            this.memoryCalls[address].message = value.split(',');
                            this.memoryCalls[address].notify();
                        }
                    }
                }
                break;
            // case PCODE_COMMANDS.GET_PROPERTY:
            //     this._getProperty.notify();
            //     break;
            // case PCODE_COMMANDS.SET_PROPERTY:
            //     this._setProperty.notify();
            //     break;
            case PCODE_COMMANDS.SET_MEMORY:
                if (message.reply !== 'A') {
                    console.log('SET_MEMORY ERROR');
                } else {
                    console.log('SET_MEMORY OK');
                    this.memorySet.notify();
                }
                break;
            case PCODE_COMMANDS.REQUEST_LOGIN:
                this.loginRequest.message = message.data;
                this.loginRequest.notify();
                break;
            case PCODE_COMMANDS.SET_PASSWORD:
                if (message.reply !== 'A') {
                    this.addDebugMessage('Password incorrect', false, 3000);
                } else {
                    this.addDebugMessage('Password updated', false, 3000);
                }
                break;
            case PCODE_COMMANDS.PAUSE:
                if (this.pauseDevice !== undefined) {
                    this.pauseDevice.notify();
                }
                break;
            case PCODE_COMMANDS.REBOOT:
                if (message.reply === REPLY_DENIED) {
                    store.dispatch({
                        type: 'debug/setDebugState',
                        payload: DEBUG_STATE.PASSWORD_REQUIRED,
                    });
                }
                break;
            default:

                break;
        }
    }

    socketEmit(command: string, data: any = '') {
        const socket = this.socket;
        if (socket) {
            socket.emit(command, data, (err: any) => {
                if (err) {
                    console.log(`${command} error: ${err}`);
                }
            });
        }
    }

    getDeviceState() {
        const { debug } = store.getState();
        const { device, debugState } = debug;
        if (device === undefined || !this.debugging
            || ![DEBUG_STATE.DEBUG, DEBUG_STATE.PAUSED].includes(debugState)) {
            return;
        }
        this.sendPCommand(device.mac, 'PC');
    }

    handleBuzz(device: any) {
        this.socketEmit('buzz', device);
    }

    async handleFirmwareUpload(binary: ArrayBufferLike, mac: string) {
        const { devices } = store.getState().debug;
        let device;
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].mac === mac) {
                device = devices[i];
                break;
            }
        }
        if (!device) {
            return;
        }
        this.setDevice(device);
        const taskId = new Date().getTime().toString();
        this.tasks.push({
            id: taskId,
            type: DebuggerTaskType.UPLOAD_FIRMWARE,
            data: {
                device,
                binary,
            },
        });
        this.addDebugMessage('Uploading Firmware', true, undefined, taskId, 0);
        this.deviceResetQuery = new Subject();
        this.sendPCommand(mac, PCODE_COMMANDS.RESET_PROGRAMMING_REBOOT);
        setTimeout(() => {
            if (this.deviceResetQuery.message !== REPLY_OK) {
                this.sendPCommand(mac, PCODE_COMMANDS.RESET_PROGRAMMING_REBOOT);
            }
        }, 3000);
        await this.deviceResetQuery.wait(10000);
        if (this.deviceResetQuery.message !== REPLY_OK) {
            this.addDebugMessage('Device did not respond to reset command', false, 3000);
            return;
        }

        this.socketEmit('application', {
            data: binary,
            mac,
        });
    }

    handleReboot(device: any) {
        this.socketEmit('reboot', device);
    }

    setDevice(device: any) {
        store.dispatch({
            type: 'debug/setDevice',
            payload: device,
        });
    }

    startUpload(binary: ArrayBufferLike | undefined, mac: string, debug: boolean = true, method?: string, files?: any[], baudRate?: number) {
        const { device } = store.getState().debug;
        const taskId = new Date().getTime().toString();
        const project: ProjectConfiguration | null = ProjectInstance.getInstance();
        let deviceDefinition = project ? PlatformUtils.getDeviceDefinition(project.device.id) : undefined;
        if (deviceDefinition.vendor === 'tibbo') {
            deviceDefinition = undefined;
        }
        for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].type === DebuggerTaskType.UPLOAD_APPLICATION) {
                this.tasks.splice(i, 1);
                i--;
            }
        }
        this.tasks.push({
            id: taskId,
            type: DebuggerTaskType.UPLOAD_APPLICATION,
            data: {
                device,
                debug,
                binary,
            },
        });

        this.socketEmit('application', {
            data: binary,
            mac,
            files,
            method,
            baudRate,
            deviceDefinition,
        });
        this.addDebugMessage('Uploading application', true, undefined, taskId, 0);
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.UPLOADING,
        });
    }

    async handleDebug(device: any, project: ProjectConfiguration) {
        const { debugState, runMode } = store.getState().debug;
        if ((debugState === DEBUG_STATE.PAUSED && this.debugging) || !project) {
            this.sendPlay(device);
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.DEBUG,
            });
            if (runMode === 'simulator') {
                store.dispatch({
                    type: 'debug/setRunMode',
                    payload: 'simulator',
                });
            }
            this.addDebugMessage('Debug Started', false, 3000);
            this.debugStarted = true;
            return;
        }
        this.debugging = true;
        const variables = project.getVariables();
        for (let i = 0; i < variables.length; i++) {
            const variable = variables[i];
            store.dispatch({
                type: 'debug/setVariable',
                payload: {
                    name: variable.getSettingValue('VARNAME'),
                    value: '',
                },
            });
        }
        const projectJSON = project.toJson();
        const projectId = project.project_id;
        store.dispatch({
            type: 'messages/clearMessages',
            payload: '',
        });
        this.refresh();
        this.sendPCommand(device.mac, PCODE_COMMANDS.INFO);
        this.getDeviceInfo = new Subject();
        await this.getDeviceInfo.wait(5000);
        let found = false;
        if (this.getDeviceInfo.message !== undefined) {
            found = true;
        }

        let foundIndex;
        const { devices } = store.getState().debug;
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].mac === device.mac) {
                found = true;
                foundIndex = i;
                break;
            }
        }

        if (!found) {
            this.debugging = false;
            this.debugStarted = false;
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
            this.addDebugMessage('Device not found', false, 0);
            return;
        }

        this.project = project;
        this.memoryCalls = [];
        store.dispatch({
            type: 'debug/setDevice',
            payload: device,
        });
        store.dispatch({
            type: 'debug/setProgress',
            payload: 0,
        });
        store.dispatch({
            type: 'debug/clearConsole',
            payload: '',
        });
        // already compiled but not uploaded
        const { debug } = store.getState();
        if (debug.binary !== undefined) {
            const device = debug.device;
            // get the binary from the device
            const { projects } = store.getState().projectData;
            if (projects[projectId].binaryId !== undefined) {
                if (this.getDeviceInfo.message !== undefined
                    && this.getDeviceInfo.message.indexOf(projects[projectId].binaryId) > -1) {
                    this.sendRun();
                    return;
                }
                this.startUpload(this.tpc, device.mac);
                return;
            }
        }

        // already compiled and uploaded
        // if (this.projectUpdatedAt === project.updatedAt
        //     && this.pdb !== undefined) {
        //     this.sendRun();
        //     return;
        // }
        this.pdb = undefined;
        this.projectUpdatedAt = project.updatedAt;

        try {
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
            const files = await this.getCode(projectJSON);
            this.files = files;
            for (let i = 0; i < files.length; i++) {
                if (files[i].name === 'Cody.json') {
                    files.splice(i, 1);
                }
                if (files[i].name.endsWith('.tpr')) {
                    const tpr = ini.parse(files[i].contents);
                    this.tpr = tpr;
                }
            }
            const project = {
                ...projectJSON,
                project_id: projectId,
            };
            const result = await this.compile(project, files);
            if (!result) {
                // canceled
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
                return;
            }
            const buf = Buffer.from(result.binary);
            this.pdb = Buffer.from(result.symbols);
            this.tobj = new TOBJ(this.pdb);
            this.tpc = buf;
            const tpcUID = this.getTPCUID();
            const { debug } = store.getState();
            store.dispatch({
                type: projectSetBinaryId.type,
                payload: {
                    projectId,
                    binaryId: tpcUID,
                },
            });
            const device = debug.device;
            if (this.tpc) {
                store.dispatch({
                    type: debuggerSetBinary.type,
                    payload: binToBase64(this.tpc),
                });
                this.startUpload(this.tpc, device.mac);
            }
        } catch (e: any) {
            if (e?.message) {
                const error = JSON.parse(e.message);
                const errorLines = error.data.output;
                store.dispatch({
                    type: 'debug/clearConsole',
                    payload: '',
                });
                store.dispatch({
                    type: 'debug/addToConsole',
                    payload: errorLines,
                });
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
                this.addDebugMessage(`Error: ${error.status}`);
            }
        }
    }

    refresh() {
        store.dispatch({
            type: 'debug/setDevices',
            payload: [],
        });
        this.socketEmit('refresh');
    }

    async sendRun() {
        const { debugState, device } = store.getState().debug;
        if (!this.debugging) {
            return;
        }
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.STARTING,
        });
        const startMessageId = this.addDebugMessage('Debug Starting...');
        let storageAddressStart = 0;
        const buf = this.pdb;
        if (!buf) {
            this.addDebugMessage('Binary not found');
            return;
        }
        const platformSize = buf.readUInt32LE(12);
        const globalAllocationSize = buf.readUInt32LE(16);
        const stackSize = buf.readUInt32LE(20);
        const localAllocSize = buf.readUInt32LE(24);

        storageAddressStart = platformSize
            + globalAllocationSize + stackSize + localAllocSize;

        this.socketEmit('set_pdb_storage_address', {
            mac: device.mac,
            data: storageAddressStart,
        });
        this.handleReboot(device);
        this.pcodestate = new Subject();
        await (new Promise((resolve) => setTimeout(resolve, 500)));
        this.sendPCommand(device.mac, 'PC');
        await this.pcodestate.wait(10000);
        store.dispatch({
            type: 'messages/removeMessage',
            payload: startMessageId,
        });
        this.sendPlay(device);
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.DEBUG,
        });
        this.addDebugMessage('Debug Started', false, 3000);
        this.debugStarted = true;
    }

    sendPlay(device: any) {
        const breakpoints = this.getBreakpoints();
        this.sendPCommand(device.mac, 'PR', `+${breakpoints}`);
        store.dispatch({
            type: 'debug/setCurrentBlockBreakpoint',
            payload: undefined,
        });
    }

    async sendPause() {
        await this.waitForPause();
        this.addDebugMessage('Debug Paused', false, 3000);
    }

    async waitForPause() {
        const { device } = store.getState().debug;
        if (device.type !== 'tios') {
            return;
        }
        this.pauseDevice = new Subject();
        this.sendPCommand(device.mac, PCODE_COMMANDS.PAUSE);
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.PAUSED,
        });
        await this.pauseDevice.wait(3000);
    }

    async sendStop() {
        const { device, debugState, devices } = store.getState().debug;
        store.dispatch({
            type: 'messages/clearMessages',
            payload: '',
        });
        this.debugging = false;
        this.debugStarted = false;
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.EMPTY,
        });

        if (this.codeRequestCancelTokenSource) {
            this.codeRequestCancelTokenSource.cancel('Operation canceled by stop command.');
            this.codeRequestCancelTokenSource = null;
        }

        store.dispatch({
            type: 'debug/debuggerDetachSerial',
        });
        if (!device) {
            return;
        }
        await this.waitForPause();
        this.addDebugMessage('Debug Stopped', false, 3000);
        if (debugState === DEBUG_STATE.UPLOADING) {
            this.socketEmit('application', {
                mac: device.mac,
                data: '',
            });
            store.dispatch({
                type: 'debug/setProgress',
                payload: 0,
            });
        }
        const { device: currentDevice } = store.getState().debug;

        if (currentDevice && currentDevice.mac === device.mac) {
            store.dispatch({
                type: 'debug/setDevice',
                payload: {
                    ...device,
                    pcode: PCODE_STATE_STOPPED,
                },
            });
        }
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.EMPTY,
        });
    }

    async getVariable(variableName: string) {
        const { debugState, device } = store.getState().debug;
        if (!this.project) {
            return;
        }
        await this.waitForPause();
        store.dispatch({
            type: 'debug/setVariable',
            payload: {
                name: variableName,
                value: '',
            },
        });
        await this.readVariable(variableName);
        if (debugState === DEBUG_STATE.DEBUG) {
            this.sendPlay(device);
        }
    }

    async getVariables() {
        const { debugState, device } = store.getState().debug;
        if (!this.project) {
            return;
        }
        await this.waitForPause();
        const variables = this.project.getVariables();
        for (let i = 0; i < variables.length; i++) {
            const variableName = variables[i].getSettingValue('VARNAME');
            store.dispatch({
                type: 'debug/setVariable',
                payload: {
                    name: variableName,
                    value: '',
                },
            });
        }
        for (let i = 0; i < variables.length; i++) {
            const variableName = variables[i].getSettingValue('VARNAME');
            await this.readVariable(variableName);
        }
        if (debugState === DEBUG_STATE.DEBUG) {
            this.sendPlay(device);
        }
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.DEBUG,
        });
    }

    async deviceLogin(mac: string, password: string) {
        this.loginRequest = new Subject();
        this.sendPCommand(mac, PCODE_COMMANDS.REQUEST_LOGIN, '');
        await this.loginRequest.wait(5000);
        const hash = md5.arrayBuffer(password);
        const h2 = md5.create();
        h2.update(hash);
        h2.update(this.loginRequest.message);
        const pHash = h2.hex();
        this.loginRequest = new Subject();
        this.sendPCommand(mac, PCODE_COMMANDS.LOGIN, pHash);
        await this.loginRequest.wait(5000);
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.LOGIN,
        });
        if (this.loginRequest.message !== REPLY_OK) {
            this.resetState();
            this.addDebugMessage('Login Failed', false, 0);
            return;
        }
        if (this.tasks.length > 0) {
            const task = this.tasks[0];
            switch (task.type) {
                case DebuggerTaskType.UPLOAD_APPLICATION:
                    this.startUpload(task.data.binary, task.data.device.mac, task.data.debug);
                    break;
                case DebuggerTaskType.UPLOAD_FIRMWARE:
                    this.handleFirmwareUpload(task.data.binary, task.data.device.mac);
                    break;
                default:

                    break;
            }
            this.removeTask(task.id);
        }
    }

    async setPassword(mac: string, oldPassword: string, newPassword: string) {
        await this.deviceLogin(mac, oldPassword);
        if (this.loginRequest.message !== 'A') {
            this.addDebugMessage('Invalid Password', false, 0);
            return;
        }
        let pHash = md5(newPassword);
        if (newPassword === '') {
            pHash = '';
        }
        this.sendPCommand(mac, PCODE_COMMANDS.SET_PASSWORD, pHash);
    }

    async readVariable(variableName: string) {
        let variable;
        if (!this.tobj) {
            return;
        }
        for (let i = 0; i < this.tobj.variables.length; i++) {
            if (this.tobj.variables[i].name === variableName) {
                variable = this.tobj.variables[i];
                const variableAddress = variable.address.dwAddress;
                const { output, length } = await this.getVariableTIOS(variableAddress, variable.dataType, variable.name);
                store.dispatch({
                    type: 'debug/setVariable',
                    payload: {
                        name: variableName,
                        value: output,
                    },
                });
                break;
            }
        }
    }

    async setVariable(variableName: string, value: string) {
        const { debugState, device } = store.getState().debug;
        if (this.simulator) {
            let variableValue: any = value;
            // get variable data type
            const project: any = ProjectInstance.getInstance();
            const variable = project.getVariableByName(variableName);
            if (variable?.getSettingValue('DATATYPE') !== 'string') {
                variableValue = Number(variableValue);
            }
            this.simulator.postMessage({ type: 'var_set', name: variableName, value: variableValue });
            return;
        }
        const mac = device.mac;
        let variable: TOBJVariableEntry;
        await this.waitForPause();
        this.memorySet = new Subject();
        await this.readVariable(variableName);
        if (!this.tobj) {
            return;
        }
        for (let i = 0; i < this.tobj.variables.length; i++) {
            if (this.tobj.variables[i].name === variableName) {
                variable = this.tobj.variables[i];
                const dataType: TOBJDataType = variable.dataType;
                const tmpAddress = variable.address.dwAddress.toString(16).padStart(4, '0');
                switch (dataType.dataType) {
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_STRING:
                        {
                            const strLength = toHexString(value.length);
                            const maxLength = toHexString(variable.dataType.typeDescriptionInline);
                            let variableAddress = tmpAddress;
                            if (variable.flags.isByref) {
                                const refAddress = variable.address.dwAddress.toString(16).padStart(4, '0');
                                this.memoryCalls[refAddress] = new Subject();
                                this.sendPCommand(mac, PCODE_COMMANDS.GET_MEMORY, `${refAddress},04`);
                                await this.memoryCalls[refAddress].wait(COMMAND_WAIT_TIME);
                                variableAddress = parseInt(this.memoryCalls[refAddress].message[3]
                                    + this.memoryCalls[refAddress].message[2]
                                    + this.memoryCalls[refAddress].message[1]
                                    + this.memoryCalls[refAddress].message[0], 16).toString(16).padStart(4, '0');
                                this.memoryCalls[refAddress] = undefined;
                            }
                            const strContents: Array<string> = [];
                            for (let i = 0; i < value.length; i++) {
                                strContents.push(toHexString(value.charCodeAt(i)));
                            }
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${variableAddress},${strLength},${maxLength},${strContents.join(',')}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_CHAR:
                        this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(value)}`);
                        await this.memorySet.wait(COMMAND_WAIT_TIME);
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_BYTE:
                        this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(value)}`);
                        await this.memorySet.wait(COMMAND_WAIT_TIME);
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_SHORT:
                        {
                            let shortValue = Number(value);
                            if (shortValue < 0) {
                                shortValue += 65536;
                            }
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(shortValue & 0xff)},${toHexString(shortValue >> 8 & 0xff)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_WORD:
                        {
                            const wordValue = Number(value);
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(wordValue & 0xff)},${toHexString(wordValue >> 8 & 0xff)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_LONG:
                        {
                            let longValue = Number(value);
                            if (longValue < 0) {
                                longValue += 2147483647;
                            }
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY,
                                `${tmpAddress},`
                                + `${toHexString(longValue & 0xff)},${toHexString(longValue >> 8 & 0xff)},`
                                + `${toHexString(longValue >> 16 & 0xff)},${toHexString(longValue >> 24 & 0xff)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_DWORD:
                        {
                            const dwordValue = Number(value);
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY,
                                `${tmpAddress},`
                                + `${toHexString(dwordValue & 0xff)},${toHexString(dwordValue >> 8 & 0xff)},`
                                + `${toHexString(dwordValue >> 16 & 0xff)},${toHexString(dwordValue >> 24 & 0xff)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_REAL:
                        {
                            const realValue = Number(value);
                            const hexVal = floatToBytes(realValue);
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY,
                                `${tmpAddress},`
                                + `${hexVal.substring(6)},${hexVal.substring(4, 6)},`
                                + `${hexVal.substring(2, 4)},${hexVal.substring(0, 2)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    case TOBJ_DATA_TYPES.TOBJ_TYPE_BOOLEAN:
                        {
                            const boolVal = (value.toLowerCase() === 'true' || Number(value) === 1) ? 1 : 0;
                            this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(boolVal)}`);
                            await this.memorySet.wait(COMMAND_WAIT_TIME);
                        }
                        break;
                    default:
                        this.sendPCommand(mac, PCODE_COMMANDS.SET_MEMORY, `${tmpAddress},${toHexString(value)}`);
                        await this.memorySet.wait(COMMAND_WAIT_TIME);
                        break;
                }
            }
        }
        await this.readVariable(variableName);
        if (debugState === DEBUG_STATE.DEBUG) {
            this.sendPlay(device);
        }
    }

    postText(text: string) {
        this.socketEmit('console', text);
    }

    async getVariableTIOS(address: number, dataType: any, name = ''): Promise<{ output: string, length: number }> {
        const { device } = store.getState().debug;
        let outputString = '';
        let val: number;
        let length = 0;
        let tmpAddress = address.toString(16).padStart(4, '0');
        this.memoryCalls[tmpAddress] = new Subject();
        // console.log(`get variable: ${name} at ${address.toString()}`);
        try {
            switch (dataType.dataType) {
                case TOBJ_DATA_TYPES.TOBJ_TYPE_STRING:
                    {
                        this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},02`);
                        await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                        const stringSize = parseInt(this.memoryCalls[tmpAddress].message[0], 16);
                        let index = 0;
                        address += 2;
                        let blocks = Math.floor(stringSize / READ_BLOCK_SIZE);
                        if (stringSize % READ_BLOCK_SIZE !== 0) {
                            blocks++;
                        }
                        for (let i = 0; i < blocks; i++) {
                            let count = READ_BLOCK_SIZE;
                            if (index + count > stringSize) {
                                count = stringSize - index;
                            }
                            tmpAddress = address.toString(16).padStart(4, '0');
                            this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},${count.toString(16).padStart(2, '0')}`);
                            this.memoryCalls[tmpAddress] = new Subject();
                            await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                            for (let i = 0; i < this.memoryCalls[tmpAddress].message.length; i++) {
                                const charCode = parseInt(this.memoryCalls[tmpAddress].message[i], 16);
                                outputString += String.fromCharCode(charCode);
                            }
                            this.memoryCalls[tmpAddress] = undefined;
                            index += count;
                            address += count;
                        }
                        length = 2 + stringSize;
                    }
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_CHAR:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},01`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    val = parseInt(this.memoryCalls[tmpAddress].message[0], 16);
                    if (val > 127) val -= 127;
                    outputString = val.toString();
                    length = 1;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_BYTE:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},01`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    outputString = parseInt(this.memoryCalls[tmpAddress].message[0], 16).toString();
                    length = 1;
                    break;

                case TOBJ_DATA_TYPES.TOBJ_TYPE_SHORT:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},02`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    val = parseInt(this.memoryCalls[tmpAddress].message[1] + this.memoryCalls[tmpAddress].message[0], 16);
                    if (val > 32767) val -= 65536;
                    outputString = val.toString();
                    length = 2;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_WORD:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},02`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    outputString = (parseInt(this.memoryCalls[tmpAddress].message[1] + this.memoryCalls[tmpAddress].message[0], 16)).toString();
                    length = 2;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_LONG:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},04`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    val = parseInt(this.memoryCalls[tmpAddress].message[3] + this.memoryCalls[tmpAddress].message[2]
                        + this.memoryCalls[tmpAddress].message[1] + this.memoryCalls[tmpAddress].message[0], 16);
                    if (val > 2147483647) val -= 2147483647;
                    outputString = val.toString();
                    length = 4;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_DWORD:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},04`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    outputString = (parseInt(this.memoryCalls[tmpAddress].message[3] + this.memoryCalls[tmpAddress].message[2]
                        + this.memoryCalls[tmpAddress].message[1] + this.memoryCalls[tmpAddress].message[0], 16)).toString();
                    length = 4;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_REAL:
                    {
                        this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},04`);
                        await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                        // eslint-disable-next-line prefer-template
                        const ff = parseFloat('0x' + this.memoryCalls[tmpAddress].message[3] + this.memoryCalls[tmpAddress].message[2]
                            + this.memoryCalls[tmpAddress].message[1] + this.memoryCalls[tmpAddress].message[0]);
                        outputString = ff.toString();
                        length = 4;
                    }
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_BOOLEAN:
                    this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},01`);
                    await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                    outputString = parseInt(this.memoryCalls[tmpAddress].message[0], 16) === 0 ? 'false' : 'true';
                    length = 1;
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_ENUM:
                    {
                        this.sendPCommand(device.mac, PCODE_COMMANDS.GET_MEMORY, `${tmpAddress},01`);
                        await this.memoryCalls[tmpAddress].wait(COMMAND_WAIT_TIME);
                        const enumValue = parseInt(this.memoryCalls[tmpAddress].message[0], 16);
                        if (dataType.typeDescription !== undefined) {
                            for (let i = 0; i < dataType.typeDescription.enumEntries.length; i++) {
                                if (dataType.typeDescription.enumEntries[i].value === enumValue) {
                                    outputString = `${dataType.typeDescription.enumEntries[i].name} (${dataType.typeDescription.enumEntries[i].value})`;
                                }
                            }
                        }
                        length = 1;
                    }
                    break;
                case TOBJ_DATA_TYPES.TOBJ_TYPE_STRUCT:

                    break;
                default:

                    break;
            }
        } catch (ex: any) {
            console.log(`error getting variable at ${address.toString()}`);
            console.log(ex.toString());
        }
        this.memoryCalls[tmpAddress] = undefined;

        return { output: outputString, length };
    }

    addDebugMessage(message: string, cancellable: boolean = false, delay?: number, id?: string, progress?: number) {
        const messageId = id || generateId();
        store.dispatch({
            type: 'messages/addMessage',
            payload: {
                id: messageId,
                title: 'Debug',
                message,
                delay,
                cancellable,
                progress,
            },
        });
        return messageId;
    }

    compile(project: any, files: any[], debug: boolean = true): Promise<DebuggerCompileResult | undefined> {
        return new Promise(async (resolve, reject) => {
            try {
                let device = project.device;
                if (project.runtime === 'zephyr') {
                    const projectDevice = PlatformUtils.getDevice(project.device);
                    if (projectDevice) {
                        device = projectDevice.meta.zephyrName;
                    }
                }
                const buildTaskResponse = await axiosInstance.post(`${process.env.API_URL}/api/tasks`, {
                    project: {
                        id: project.id,
                        device: project.device,
                        runtime: project.runtime,
                    },
                    files,
                    command: 'build',
                    debug: debug ? 'on' : 'off',
                });
                const compileMessageId = buildTaskResponse.data.output.puuid;
                store.dispatch({
                    type: 'messages/clearMessages',
                });
                this.addDebugMessage('Compiling...', true, 0, compileMessageId, 0);
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.BUILDING,
                });

                if (buildTaskResponse.data.status === 'error') {
                    return reject(buildTaskResponse.data.output);
                }
                for (let i = 0; i < this.tasks.length; i++) {
                    if (this.tasks[i].type === DebuggerTaskType.COMPILE) {
                        axiosInstance.delete(`${process.env.API_URL}/api/tasks/${this.tasks[i].id}`);
                        this.removeTask(this.tasks[i].id);
                    }
                }
                this.tasks.push({
                    type: DebuggerTaskType.COMPILE,
                    id: compileMessageId,
                    data: {
                        debug,
                        files,
                    },
                });
                let progressCount = 0;
                const progressChunk = 1 / files.length * 100;

                const pollTimer = setInterval(async () => {
                    let task;
                    for (let i = 0; i < this.tasks.length; i++) {
                        if (this.tasks[i].id === compileMessageId) {
                            task = this.tasks[i];
                            break;
                        }
                    }
                    if (!task) {
                        clearInterval(pollTimer);
                        return resolve(undefined);
                    }

                    try {
                        const response = await axiosInstance.get(`${process.env.API_URL}/api/tasks/${compileMessageId}`);
                        if (response.data.status === 'error'
                            || response.data.status === 'aborted'
                            || response.data.status === 'unknown') {
                            store.dispatch({
                                type: 'debug/setConsole',
                                payload: response.data.data.output,
                            });
                            store.dispatch({
                                type: 'debug/setDebugState',
                                payload: DEBUG_STATE.EMPTY,
                            });
                            throw new Error(JSON.stringify(response.data));
                        }
                        if (response.data.status === 'completed') {
                            this.removeTask(compileMessageId);
                            store.dispatch({
                                type: 'debug/setConsole',
                                payload: response.data.data.output,
                            });
                            if (response.data.data.binary) {
                                const result: DebuggerCompileResult = {
                                    binary: Buffer.from(response.data.data.binary.data),
                                    hex: response.data.data.hex ? Buffer.from(response.data.data.hex.data) : undefined,
                                    symbols: response.data.data.symbols ? Buffer.from(response.data.data.symbols.data) : undefined,
                                    output: response.data.data.output,
                                };

                                resolve(result);
                            } else {
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.EMPTY,
                                });
                                posthog.capture('compilation_error', {
                                    output: response.data.data.output,
                                    project,
                                });
                                reject();
                            }
                        } else {
                            if (response.data.data.output) {
                                store.dispatch({
                                    type: 'debug/setConsole',
                                    payload: response.data.data.output,
                                });
                            }
                            if (response.data.data.progress) {
                                store.dispatch({
                                    type: 'messages/updateMessage',
                                    payload: {
                                        id: task.id,
                                        message: {
                                            progress: response.data.data.progress * 100,
                                        },
                                    },
                                });
                            } else {
                                progressCount += progressChunk;
                                store.dispatch({
                                    type: 'messages/updateMessage',
                                    payload: {
                                        id: task.id,
                                        message: {
                                            progress: progressCount,
                                        },
                                    },
                                });
                            }
                        }
                    } catch (ex) {
                        clearInterval(pollTimer);
                        store.dispatch({
                            type: 'messages/removeMessage',
                            payload: compileMessageId,
                        });
                        return reject(ex);
                    }
                }, 1000);
            } catch (ex) {
                reject(ex);
            }
        });
    }

    getCode(project: any, isSimulator = false): Promise<any[]> {
        const taskId = generateId();
        return new Promise(async (resolve, reject) => {
            if (this.codeRequestCancelTokenSource) {
                this.codeRequestCancelTokenSource.cancel('New code generation request started.');
            }
            this.codeRequestCancelTokenSource = axios.CancelToken.source();
            try {
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
                this.addDebugMessage('Generating Code...', false, 0, taskId);
                this.tasks.push({
                    type: DebuggerTaskType.GENERATE_CODE,
                    id: taskId,
                    data: null,
                });
                const codePostResponse = await axiosInstance.post(`${process.env.API_URL}/api/projects/code/`, {
                    params: {
                        project: {
                            ...project,
                            runtime: !isSimulator ? project.runtime : 'simulator',
                        },
                        debug: true,
                    },
                }, { cancelToken: this.codeRequestCancelTokenSource.token });
                this.codeRequestCancelTokenSource = null;
                const files = codePostResponse.data;
                for (let i = 0; i < files.length; i++) {
                    if (files[i].contents && typeof files[i].contents === 'string') {
                        files[i].contentsOriginal = files[i].contents;
                        if (!isSimulator) {
                            files[i].contents = files[i].contents.replace(/['/#]\*\*\*\*[a-zA-Z0-9_]+\*\*\*\*['/#](\r\n)?/g, '');
                        }
                    }
                }
                resolve(files);
            } catch (ex: any) {
                this.codeRequestCancelTokenSource = null;
                if (axios.isCancel(ex)) {
                    reject(new Error(JSON.stringify({
                        status: 'aborted',
                        data: {
                            output: 'Code generation cancelled',
                        },
                    })));
                } else {
                    reject(ex);
                }
            } finally {
                this.removeTask(taskId);
            }
        });
    }

    resetState() {
        for (let i = 0; i < this.tasks.length; i++) {
            this.removeTask(this.tasks[i].id);
        }
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.EMPTY,
        });
    }

    removeTask(taskId: string) {
        for (let i = 0; i < this.tasks.length; i++) {
            if (this.tasks[i].id === taskId) {
                this.tasks.splice(i, 1);
                break;
            }
        }
        store.dispatch({
            type: 'messages/removeMessage',
            payload: taskId,
        });
    }

    getTPCUID() {
        const binStr = this.tpc.toString();
        const startStr = `<FD>\x00${this.project.name}`;
        const startIndex = binStr.indexOf(startStr);
        const endIndex = binStr.indexOf(this.project.device.id);
        let tpcUID = binStr.substring(startIndex + startStr.length + 1, endIndex - 1);
        if (tpcUID.length > 36) {
            tpcUID = tpcUID.substring(tpcUID.length - 36);
        }
        return tpcUID;
    }

    httpRequest(request: HTTPMessage) {
        this.socketEmit('http', request);
    }

    getBreakpoints() {
        let breakpointStr = '';
        const breakpoints = this.getBreakpointFiles();
        Object.keys(breakpoints).forEach((fileName: string) => {
            let sourceFile;
            if (!this.tobj) {
                return;
            }
            for (let i = 0; i < this.tobj.sourceFiles.length; i++) {
                const parts = this.tobj.sourceFiles[i].fileName.split('\\');
                if (parts[parts.length - 1] === fileName) {
                    sourceFile = this.tobj.sourceFiles[i];
                    break;
                }
            }
            if (!sourceFile) {
                return;
            }

            for (let i = 0; i < breakpoints[fileName].length; i++) {
                const line = breakpoints[fileName][i];
                for (let j = 0; j < sourceFile.lines.length; j++) {
                    if (sourceFile.lines[j].line === line + 1) {
                        const lineAddress = sourceFile.lines[j].address;
                        breakpointStr += `${Number(lineAddress).toString(16).toUpperCase().padStart(4, '0')},`;
                        break;
                    }
                }
            }
        });
        if (breakpointStr !== '') {
            breakpointStr = breakpointStr.substring(0, breakpointStr.length - 1);
        }
        breakpointStr = breakpointStr.toLowerCase();
        store.dispatch({
            type: 'debug/setBreakpoints',
            payload: breakpoints,
        });
        if (this.simulator) {
            const simulatorBreakpoints: number[] = [];
            Object.keys(breakpoints).forEach((fileName: string) => {
                const lines = breakpoints[fileName];
                for (let i = 0; i < lines.length; i++) {
                    simulatorBreakpoints.push(Number(lines[i]));
                }
            });
            this.simulator.postMessage({
                type: 'breakpoints',
                data: {
                    breakpoints: simulatorBreakpoints,
                },
            });
        }
        return breakpointStr;
    }

    getBlockBreakpoint(featureId: string, sourceProject?: ProjectConfiguration): any {
        const breakpoints: any = {};
        let project: ProjectConfiguration | undefined | null = ProjectInstance.getInstance();
        if (sourceProject) {
            project = sourceProject;
        }
        if (!project) {
            return breakpoints;
        }
        const feature: BaseNode = project.getFeature(featureId) as BaseNode;
        let files = this.files;
        if (!feature) {
            return breakpoints;
        }
        if (files === undefined) {
            const { code } = store.getState().projectData;
            files = code;
        }
        if (!files) {
            return;
        }
        if (this.simulator) {
            files = this.debugFiles;
            files = files.filter((file: any) => file.name === 'simulator/main.js');
            if (!files) {
                return breakpoints;
            }
            const lines = files[0].transformedContents.split('\n');
            for (let i = 0; i < lines.length; i++) {
                if (lines[i].indexOf(featureId) !== -1) {
                    // await handleBreakpoint(464, "mbg3uycquyt3enl1s5");
                    // find the line number
                    const match = lines[i].match(/await handleBreakpoint\((\d+), "(.*)"\)/);
                    if (match) {
                        const lineNumber = match[1];
                        breakpoints[files[0].name] = [lineNumber];
                    }
                }
            }
            return breakpoints;
        }
        const inputs = feature.getInputs();
        const codeBlocks = feature.getCodeBlocks();
        const inputPortName = inputs[0].portId;
        const links = project.getNodeLinks(feature, inputPortName);
        for (let j = 0; j < links.length; j++) {
            const link = links[j];
            const source = link.getSourceId();
            let blockLines = [];
            for (let k = 0; k < codeBlocks.length; k++) {
                if (codeBlocks[k].location === source) {
                    blockLines = codeBlocks[k].template.split('\n');
                    break;
                }
            }
            for (let k = 0; k < files.length; k++) {
                const file = files[k];
                try {
                    if (file.contentsOriginal.indexOf(source) !== -1) {
                        if (breakpoints[file.name] === undefined) {
                            breakpoints[file.name] = [];
                        }
                        const lines = file.contentsOriginal.split('\n');
                        for (let l = 0; l < lines.length; l++) {
                            if (lines[l].indexOf(source) !== -1) {
                                let found = false;
                                let index = l;
                                while (!found && index < lines.length) {
                                    index++;
                                    if (blockLines.length > 0) {
                                        for (let m = 0; m < blockLines.length; m++) {
                                            if (blockLines[m].trim() !== ''
                                                && blockLines[m].trim() === lines[index].trim()
                                                && blockLines[m].trim() !== '') {
                                                found = true;
                                                break;
                                            }
                                        }
                                    }
                                    if (found) {
                                        breakpoints[file.name].push(index);
                                    }
                                }
                            }
                        }
                    }
                } catch (ex) {
                    // maybe not text file
                }
            }
        }
        return breakpoints;
    }

    getBreakpointFiles(): any {
        const { blockBreakpoints } = store.getState().debug;
        let files = this.files;
        if (files === undefined) {
            const { code } = store.getState().projectData;
            files = code;
        }
        if (!files) {
            return;
        }
        const breakpoints: any = {};
        for (let i = 0; i < blockBreakpoints.length; i++) {
            const featureBreakpoints = this.getBlockBreakpoint(blockBreakpoints[i]);
            Object.keys(featureBreakpoints).forEach((fileName: string) => {
                if (breakpoints[fileName] === undefined) {
                    breakpoints[fileName] = [];
                }
                for (let j = 0; j < featureBreakpoints[fileName].length; j++) {
                    breakpoints[fileName].push(featureBreakpoints[fileName][j]);
                }
            });
        }
        return breakpoints;
    }

    injectSimulatorBlockHighlighters = (code: string) => {
        const lines = code.split('\n');
        const project = ProjectInstance.getInstance();
        if (!project) {
            return code;
        }
        for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
            const line = lines[lineIndex];
            const match = line.match(/\/\*\*\*\*(.*?)\*\*\*\*/);
            if (match) {
                const parts = match[1].split('_');
                const variable = parts[0];
                const outputPort = parts.slice(1).join('_');
                if (variable.length > 15) {
                    const blockIds = [];
                    blockIds.push(variable);
                    const feature = project.getFeature(variable);
                    const links = project.getNodeLinks(feature, outputPort);
                    for (let i = 0; i < links.length; i++) {
                        const link = links[i];
                        const target = link.getSettingValue('TARGET_FEATURE');
                        blockIds.push(target);
                    }
                    // go back and find the last function definition
                    for (let i = lineIndex - 1; i >= 0; i--) {
                        const trimmedLine = lines[i].trim();
                        if (trimmedLine.indexOf('function ') === 0
                            && trimmedLine.indexOf('function AppBlocksSimulator') === -1
                            && trimmedLine.indexOf('function CggHandler') === -1) {
                            lines[i] = `async ${lines[i]}`;
                            break;
                        }
                    }
                    lines[lineIndex] = `${line}\n
    simulator.emit({
        eventType: 'block_highlight',
        blockIds: ${JSON.stringify(blockIds)},
    });
    await handleBreakpoint(${lineIndex}, "${blockIds[1]}");
                    `;
                }
            }
            // const trimmedLine = line.trim();
            // if (trimmedLine.indexOf('function ') === 0
            //     && trimmedLine.indexOf('function AppBlocksSimulator') === -1
            //     && trimmedLine.indexOf('function CggHandler') === -1) {
            //     line = `async ${line}`;
            // }
        }
        return lines.join('\n');
    };

    async getStack() {
        const deviceStack = [];
        deviceStack.push(this.currentDeviceState.pcodeCounter);
        const stackFrames: any[] = [];
        const stackSize = deviceStack.length;
        for (let z = stackSize - 1; z >= 0; z--) {
            for (let i = 0; i < this.tobj.sourceFiles.length; i++) {
                const lines = this.tobj.sourceFiles[i].lines;
                for (let j = 0; j < lines.length; j++) {
                    if (deviceStack[z] === lines[j].address
                        || (j < lines.length - 1 && deviceStack[z] >= lines[j].address && deviceStack[z] < lines[j + 1].address)) {
                        const line = lines[j];
                        const pp = this.tobj.sourceFiles[i].fileName.split('\\');
                        const filePath = pp[pp.length - 1];
                        let scope;
                        let scopeName = '';
                        for (let k = 0; k < this.tobj.scopes.length; k++) {
                            if (this.tobj.scopes[k].begin.sourcePosition.fileName === this.tobj.sourceFiles[i].fileName) {
                                if (line.line >= this.tobj.scopes[k].begin.sourcePosition.line
                                    && line.line <= this.tobj.scopes[k].end.sourcePosition.line) {
                                    scope = this.tobj.scopes[k];
                                    break;
                                }
                            }
                        }
                        if (scope !== undefined) {
                            for (let k = 0; k < this.tobj.functions.length; k++) {
                                if (this.tobj.functions[k].address.dwAddress === scope.begin.address) {
                                    scopeName = this.tobj.functions[k].name;
                                }
                            }

                            stackFrames.push({
                                id: deviceStack[z],
                                name: scopeName,
                                file: filePath,
                                line: line.line,
                            });
                        }

                        break;
                    }
                }
            }
        }
        if (stackFrames.length > 0) {
            const frame = stackFrames[0];
            const fileName = frame.file;
            const line = frame.line;
            // loop through current breakpoint blocks
            const { blockBreakpoints } = store.getState().debug;
            for (let i = 0; i < blockBreakpoints.length; i++) {
                const blockId = blockBreakpoints[i];
                const breakpoints = this.getBlockBreakpoint(blockId);
                if (breakpoints[fileName] !== undefined) {
                    for (let j = 0; j < breakpoints[fileName].length; j++) {
                        if (breakpoints[fileName][j] + 1 === line) {
                            store.dispatch({
                                type: 'debug/setCurrentBlockBreakpoint',
                                payload: blockId,
                            });
                            store.dispatch({
                                type: 'pages/setPageFeature',
                                payload: {
                                    page: 'appblocks',
                                    selectedFeature: blockId,
                                    shouldCenter: true,
                                },
                            });
                            return;
                        }
                    }
                }
            }
        }
    }

    async generateTcu(project: any) {
        const files = await this.getCode(project);
        const wifi = false;
        let version;
        for (let i = 0; i < project.features.length; i++) {
            if (project.features[i].id === 'wifi') {
                // dont include wifi n9
                // wifi = project.features[i].settings.ENABLED === '1';
            }
            if (project.features[i].id === 'general') {
                version = project.features[i].settings.FIRMWAREVERSION;
            }
            if (wifi !== undefined && version !== undefined) {
                break;
            }
        }

        const endpoint = 'https://apps.tibbo.com/tc_generator/generate/';

        const firmwareFile: { [string: string]: any } = {
            'TPP2W(G2)': 'tios-tpp2w(g2)-4_02_02.bin',
            'TPP3W(G2)': 'tios-tpp3w(g2)-4_02_02.bin',
        };

        const buildResult = await this.compile(project, files, false);
        const buf = Buffer.from(buildResult.binary);
        const blob = new Blob([buf], {
            type: 'application/octet-stream',
        });
        const form = new FormData();
        form.append('platform', project.device);
        form.append('tios-app', blob);
        form.append('tios-app-one', new Blob([]));
        form.append('firmware', firmwareFile[project.device]);
        form.append('version', version);
        form.append('wifi', wifi.toString());
        const res = await axiosInstance.post(endpoint, form);
        const tcuBuf = Buffer.from(res.data.file, 'base64');
        const tcuBlob = new Blob([tcuBuf], {
            type: 'application/octet-stream',
        });
        return tcuBlob;
    }

    parseCompilationError(payload: string) {
        const lines = payload.split('\n');
        const errorRegex = /([a-zA-Z0-9_-]+\.tb[s|h])\((\d+)\):\serror\sC[0-9]+:/gm;
        const otherErrorRegex = /error:/gm;
        const errors = [];
        // for tios builds
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const match = errorRegex.exec(line);
            if (match !== null) {
                const file = match[1];
                const lineNo = match[2];
                errors.push(`${match.input.substr(match.index + file.length + lineNo.length + 2)}\r\nError in file ${file} on line ${lineNo}\r\n`);
                store.dispatch({
                    type: 'messages/addMessage',
                    payload: {
                        title: 'Compilation Error',
                        message: `Error in file ${file} on line ${lineNo}:\r\n${match.input.substr(match.index + file.length + lineNo.length + 4)}`,
                        action: {
                            type: 'pages/setShowCode',
                            payload: {
                                show: true,
                                file,
                                line: Number(lineNo),
                            },
                            label: 'View',
                        },
                        cancellable: false,
                    },
                });
            }
        }
        // for zephyr builds
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (line.indexOf('ccache') === 0) {
                // error starts from next line
                let error = '';
                for (let j = i + 1; j < lines.length; j++) {
                    if (lines[j].indexOf('ninja: build stopped') === 0
                        || lines[j].indexOf('[') === 0) {
                        break;
                    }
                    const errorLine = lines[j];
                    error += `${errorLine}\n`;
                }

                const errorRegex = /(src[\\/a-zA-Z0-9_-]+\.(h|cpp|c)):([0-9]+):([0-9]+)/gm;
                const match = errorRegex.exec(error);
                if (error !== '' && match) {
                    const file = match[1];
                    const lineNo = Number(match[3]);
                    let count = 0;
                    const errorMessage = error.split('\n').map((cline) => {
                        if (cline.indexOf('error:') >= 0 && count < 1) {
                            count++;
                            return cline;
                        }
                        return '';
                    }).join('\n');

                    store.dispatch({
                        type: 'messages/addMessage',
                        payload: {
                            title: 'Compilation Error',
                            message: `Error in file ${file} on line ${lineNo}\r\n\r\n${errorMessage}`,
                            action: {
                                type: 'pages/setShowCode',
                                payload: {
                                    show: true,
                                    file,
                                    line: lineNo,
                                },
                                label: 'View',
                            },
                            cancellable: false,
                        },
                    });
                }
                break;
            }
        }
    }
}

debugMiddleware.startListening({
    actionCreator: debuggerInit,
    effect: async (action, storeInstance: any) => {
        store = storeInstance;
        if (!debuggerInstance) {
            debuggerInstance = new Debugger();
        }
        const user = store.getState().user.user;
        const selectedNetwork = store.getState().debug.selectedNetwork;
        if (selectedNetwork === 'localhost') {
            debuggerInstance.connect(undefined, '');
        } else {
            debuggerInstance.connect(user, selectedNetwork);
        }
        const projectId = action.payload;
        const projects = storeInstance.getState().projectData;
        if (projects.projects[projectId] !== undefined) {
            store.dispatch({
                type: 'debug/setDevice',
                payload: projects.projects[projectId].device,
            });
        }
    },
});

debugMiddleware.startListening({
    actionCreator: setSelectedNetwork,
    effect: async (action, storeInstance: any) => {
        store = storeInstance;
        const user = store.getState().user.user;
        if (action.payload === 'localhost') {
            debuggerInstance.connect(undefined, '');
        } else {
            debuggerInstance.connect(user, action.payload);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerClose,
    effect: async (action, storeInstance: any) => {
        if (debuggerInstance) {
            debuggerInstance.disconnect();
        }
    },
});

debugMiddleware.startListening({
    actionCreator: addToConsole,
    effect: async (action, store) => {
        if (debuggerInstance) {
            debuggerInstance.parseCompilationError(action.payload);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: setConsole,
    effect: async (action, store) => {
        if (debuggerInstance) {
            debuggerInstance.parseCompilationError(action.payload);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDeviceStepOver,
    effect: async (action, store: any) => {
        if (debuggerInstance) {
            const {
                currentBlockBreakpoint,
            } = store.getState().debug;
            // get next block
            // traverse current block and find the next block
            const project: ProjectConfiguration = ProjectInstance.getInstance();
            if (!project) {
                return;
            }
            const currentBlock = project.getFeature(currentBlockBreakpoint);
            if (!currentBlock) {
                return;
            }
            const chain = project.getOutputChain(currentBlock as BaseNode);
            // see if there are other blocks in the chain
            let breakpoints: any[] = [];
            if (chain.length !== 0) {
                // merge current breakpoints with all blocks in the chain
                const currentBreakpointLine = debuggerInstance.getBlockBreakpoint(currentBlockBreakpoint);
                // breakpoints.push(Number(currentBreakpointLine[Object.keys(currentBreakpointLine)[0]][0]));
                for (let i = 0; i < chain.length; i++) {
                    const block = chain[i];
                    const breakpoint = debuggerInstance.getBlockBreakpoint(block.getID());
                    if (!breakpoint || Object.keys(breakpoint).length === 0) {
                        continue;
                    }
                    const breakpointLine = Number(breakpoint[Object.keys(breakpoint)[0]][0]);
                    breakpoints.push(breakpointLine);
                }
                debuggerInstance.simulator.postMessage({
                    type: 'breakpoints',
                    data: {
                        breakpoints,
                    },
                });
            } else {
                const simulatorBreakpoints: number[] = [];
                breakpoints = debuggerInstance.getBreakpointFiles();
                Object.keys(breakpoints).forEach((fileName: string) => {
                    const lines = breakpoints[fileName];
                    for (let i = 0; i < lines.length; i++) {
                        simulatorBreakpoints.push(Number(lines[i]));
                    }
                });
                debuggerInstance.simulator.postMessage({
                    type: 'breakpoints',
                    data: {
                        breakpoints: simulatorBreakpoints,
                    },
                });
            }
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.DEBUG,
            });
            store.dispatch({
                type: 'debug/setCurrentBlockBreakpoint',
                payload: undefined,
            });
            debuggerInstance.simulator.postMessage({
                type: 'continue',
            });
        }
    },
});


debugMiddleware.startListening({
    actionCreator: debuggerDeviceStartDebug,
    effect: async (action, store: any) => {
        const debug = store.getState().debug;
        const {
            device, debugState, selectedNetwork, uploadMethod, runMode,
        } = store.getState().debug;

        store.dispatch({
            type: 'messages/clearMessages',
            payload: '',
        });

        if (debugState === DEBUG_STATE.PAUSED) {
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.DEBUG,
            });
            store.dispatch({
                type: 'debug/setCurrentBlockBreakpoint',
                payload: undefined,
            });
            if (runMode === 'simulator') {
                debuggerInstance.simulator.postMessage({
                    type: 'continue',
                });
            } else {
                debuggerInstance.sendPlay(device);
            }
            return;
        }
        const { project, releaseBuild } = action.payload;
        let projectInstance;
        const targetDevice = device;
        debuggerInstance.project = project;

        // clear if we are starting a new debug session
        if (debugState === 'DEBUG') {
            store.dispatch({
                type: 'debug/clearConsole',
                payload: '',
            });
        }
        let newRunMode = '';

        // if run in simulator
        if (action.payload.simulator) {
            const files = await debuggerInstance.getCode(project);
            const simulatorFiles = await debuggerInstance.getCode(project, true);
            // combine the two
            const projectCode = files;
            for (let i = 0; i < simulatorFiles.length; i++) {
                const existingFile = files.find((file: any) => file.name === simulatorFiles[i].name);
                if (!existingFile) {
                    projectCode.push({
                        name: simulatorFiles[i].name,
                        contents: simulatorFiles[i].contentsOriginal,
                    });
                }
            }
            store.dispatch({
                type: 'debug/clearConsole',
                payload: '',
            });
            store.dispatch({
                type: 'debug/addToConsole',
                payload: 'Starting Simulator...\n',
            });

            // create simulator
            debuggerInstance.simulator = new Worker(new URL('./simulatorWorker.js', import.meta.url));
            let code = simulatorFiles.find((file: any) => file.name === 'simulator/main.js').contentsOriginal;
            code = debuggerInstance.injectSimulatorBlockHighlighters(code);
            store.dispatch({
                type: 'project/setProjectCode',
                payload: projectCode,
            });
            for (let i = 0; i < simulatorFiles.length; i++) {
                if (simulatorFiles[i].name === 'simulator/main.js') {
                    simulatorFiles[i].transformedContents = code;
                }
            }
            debuggerInstance.debugFiles = simulatorFiles;
            // set context e.g. localstorage
            const projectData = store.getState().projectData;
            const projectLocalStorage = projectData.projects[project.id];
            const settings = projectLocalStorage.settings || {};
            const tables = projectLocalStorage.tables || {};
            const settingsHashes = projectLocalStorage.settingsHashes || {};
            const tablesHashes = projectLocalStorage.tablesHashes || {};
            debuggerInstance.simulator.postMessage({
                type: 'run_code',
                code,
                context: {
                    settings,
                    tables,
                    settingsHashes,
                    tablesHashes,
                },
            });
            debuggerInstance.setBreakpoints();
            debuggerInstance.simulator.onmessage = (event: any) => {
                switch (event.data.type) {
                    case 'log':
                        store.dispatch({
                            type: 'debug/addToConsole',
                            payload: `${event.data.message}\n`,
                        });
                        break;
                    case 'event':
                        switch (event.data.eventType) {
                            case 'var_set':
                                store.dispatch({
                                    type: 'debug/setVariable',
                                    payload: event.data,
                                });
                                break;
                            case 'stg_hashes':
                                store.dispatch({
                                    type: 'project/setSimulatorStoredValues',
                                    payload: {
                                        name: 'hashes',
                                        value: event.data.hashes,
                                    },
                                });
                                break;
                            case 'stg_update':
                                store.dispatch({
                                    type: 'project/setSimulatorStoredValues',
                                    payload: {
                                        name: 'settings',
                                        value: event.data.settings,
                                    },
                                });
                                break;
                            case 'tbl_hashes':
                                store.dispatch({
                                    type: 'project/setSimulatorStoredValues',
                                    payload: {
                                        name: 'tablesHashes',
                                        value: event.data.hashes,
                                    },
                                });
                                break;
                            case 'tbl_update':
                                store.dispatch({
                                    type: 'project/setSimulatorStoredValues',
                                    payload: {
                                        name: 'tables',
                                        value: event.data.tables,
                                    },
                                });
                                break;
                            case 'context_update':
                                store.dispatch({
                                    type: 'project/setSimulatorContext',
                                    payload: event.data.context,
                                });
                                break;
                            case 'block_highlight':
                                store.dispatch({
                                    type: 'debug/setBlockHighlights',
                                    payload: event.data.blockIds,
                                });
                                break;
                            case 'breakpoint':
                                store.dispatch({
                                    type: 'debug/setCurrentBlockBreakpoint',
                                    payload: event.data.id,
                                });
                                store.dispatch({
                                    type: 'debug/setDebugState',
                                    payload: DEBUG_STATE.PAUSED,
                                });
                                break;
                            default:

                                break;
                        }
                        break;
                    case 'breakpoint':
                        if (event.data.continue) {
                            // set breakpoints again after temporarily toggling off
                            const { blockBreakpoints } = store.getState().debug;
                            if (debuggerInstance.simulator) {
                                const simulatorBreakpoints: any = {};
                                for (let i = 0; i < blockBreakpoints.length; i++) {
                                    simulatorBreakpoints[blockBreakpoints[i]] = true;
                                }
                                debuggerInstance.simulator.postMessage({ type: 'breakpoints', breakpoints: simulatorBreakpoints });
                            }
                        } else {
                            store.dispatch({
                                type: 'debug/setCurrentBlockBreakpoint',
                                payload: event.data.id,
                            });
                            store.dispatch({
                                type: 'debug/setDebugState',
                                payload: DEBUG_STATE.PAUSED,
                            });
                        }
                        break;
                    case 'error':
                        store.dispatch({
                            type: 'debug/addToConsole',
                            payload: `${event.data.message}\n`,
                        });
                        debuggerInstance.addDebugMessage(event.data.message, false, 4000);
                        store.dispatch({
                            type: debuggerStop.type,
                        });
                        break;
                    case 'settings':
                    default:

                        break;
                }
            };
            debuggerInstance.simulator.onerror = (event: any) => {
                console.log(event);
                store.dispatch({
                    type: 'debug/addToConsole',
                    payload: `${event.message}\n`,
                });
            };
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.DEBUG,
            });

            store.dispatch({
                type: 'debug/setRunMode',
                payload: 'simulator',
            });
            newRunMode = 'simulator';

            projectInstance = ProjectConfiguration.fromJson(project);
            store.dispatch({
                type: projectSetBinaryId.type,
                payload: {
                    projectId: project.id,
                    binaryId: project.id,
                },
            });
            store.dispatch({
                type: 'pages/setShowBottomPanel',
                payload: true,
            });
            return;
        }

        // normal run mode
        store.dispatch({
            type: 'debug/setRunMode',
            payload: newRunMode,
        });

        const uploadMethodsThatNeedProxy = [
            'bossac',
            'jlink',
            'tios',
            'openocd',
            'teensy',
        ];
        let deviceDefinition;
        // if esp32 then check browser support for web serial
        if (project !== undefined) {
            // if esp32 then check browser support for web serial
            deviceDefinition = PlatformUtils.getDeviceDefinition(project.device);
            if (deviceDefinition.soc && deviceDefinition.soc.indexOf('esp32') === 0) {
                const webSerialSupported = navigator.serial && navigator.serial.getPorts;
                if (!webSerialSupported) {
                    uploadMethodsThatNeedProxy.push('esp32');
                }
            }
        }

        if (!debug.connected && uploadMethodsThatNeedProxy.includes(uploadMethod)) {
            store.dispatch({
                type: 'pages/setShowDeviceExplorer',
                payload: true,
            });
            return;
        }
        if (targetDevice) {
            if (debug.connected) {
                store.dispatch({
                    type: 'pages/setShowDeviceExplorer',
                    payload: false,
                });
                if (releaseBuild) {
                    if (debugState === 'DEBUG') {
                        store.dispatch({
                            type: debuggerStop.type,
                        });
                    }
                    store.dispatch({
                        type: debuggerUploadRelease.type,
                        payload: project,
                    });
                    return;
                }
            }
        } else if (debug.connected || project.runtime === 'tios') {
            store.dispatch({
                type: 'pages/setShowDeviceExplorer',
                payload: true,
            });
            return;
        }
        if (project) {
            projectInstance = ProjectConfiguration.fromJson(project);
            if (project.runtime === 'micropython') {
                const baudRate = Number(projectInstance.getFeature('general')?.getSettingValue('BAUD'));
                const serialPort = new SerialPort();
                const micropythonSerial = new MicropythonSerial(serialPort);
                const files = await debuggerInstance.getCode(project);

                const taskId = makeid(8);
                try {
                    store.dispatch({
                        type: 'pages/setShowBottomPanel',
                        payload: true,
                    });
                    if (debug.connected && selectedNetwork === 'localhost') {
                        if (project.runtime === 'micropython') {
                            const includedFiles = [
                                'index.html',
                                '404.html',
                                'cgg_console.json',
                                'settings.json',
                                'dashboard_setup.json',
                                'settings_schema.json',
                                'console_Main.js.gz',
                                'console_Dashboard.js.gz',
                            ];
                            for (let i = 0; i < files.length; i += 1) {
                                const file = files[i];
                                const fileExtension = file.name.split('.').pop();
                                if (!includedFiles.includes(file.name) && fileExtension !== 'py') {
                                    files.splice(i--, 1);
                                }
                            }
                        }
                        debuggerInstance.startUpload(undefined, device.mac, !releaseBuild, 'micropython', files, baudRate);
                        debuggerInstance.debugStarted = true;
                        debuggerInstance.addDebugMessage('Uploading application', true, undefined, taskId, 0);
                        return;
                    }
                    serialPort.on('error', (error: any) => {
                        debuggerInstance.addDebugMessage(error.message, false, 4000);
                    });
                    await serialPort.connect(baudRate, true);
                    debuggerInstance.addDebugMessage('Uploading application', true, undefined, taskId, 0);
                    await micropythonSerial.enterRawMode(true);
                    for (let i = 0; i < files.length; i++) {
                        const percentage = Math.round((i / files.length) * 100);
                        await micropythonSerial.writeFileToDevice(files[i]);
                        store.dispatch({
                            type: 'messages/updateMessage',
                            payload: {
                                id: taskId,
                                message: {
                                    progress: percentage,
                                },
                            },
                        });
                    }
                    await micropythonSerial.exitRawMode();
                    store.dispatch({
                        type: 'pages/setShowBottomPanel',
                        payload: true,
                    });
                } catch (ex) {
                    console.log(ex);
                    store.dispatch({
                        type: 'messages/addMessage',
                        payload: {
                            title: 'Error',
                            message: 'Error uploading files to device',
                            cancellable: false,
                        },
                    });
                    return;
                } finally {
                    store.dispatch({
                        type: 'messages/removeMessage',
                        payload: taskId,
                    });
                }

                // Listen to data coming from the serial device.
                debuggerInstance.debugging = true;
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.DEBUG,
                });
                debuggerInstance.addDebugMessage('Upload complete', false, 6000);
                debuggerInstance.device = serialPort;
                store.dispatch({
                    type: 'debug/debuggerAttachSerial',
                    payload: {
                        baudrate: 115200,
                    },
                });
                return;
            }
            if (project.runtime === 'zephyr') {
                // esp32 can be uploaded via serial using web serial api if supported
                let serialPort;
                if (!debug.connected
                    && deviceDefinition.soc.indexOf('esp32') === 0
                    && navigator.serial !== undefined) {
                    try {
                        const ports = await navigator.serial.getPorts();
                        for (let i = 0; i < ports.length; i++) {
                            const port = ports[0];
                            await port.forget();
                            await port.cancel();
                            await port.close();
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                    try {
                        if (debuggerInstance.device) {
                            await debuggerInstance.device.disconnect();
                        }
                    } catch (ex) {
                        console.log(ex);
                    } finally {
                        debuggerInstance.device = undefined;
                    }
                    serialPort = new SerialPort();
                    serialPort.on('error', (error: any) => {
                        console.log(error);
                        debuggerInstance.addDebugMessage(error.message, false, 4000);
                    });
                    await serialPort.disconnect();
                    debuggerInstance.device = serialPort;
                    await serialPort.getPort();
                    if (!debuggerInstance.device) {
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                title: 'Error',
                                message: 'No device selected',
                                cancellable: false,
                            },
                        });
                        return;
                    }
                    store.dispatch({
                        type: 'debug/debuggerAttachSerial',
                        payload: {
                            baudrate: 115200,
                        },
                    });
                }
                store.dispatch({
                    type: 'pages/setShowBottomPanel',
                    payload: true,
                });

                if (deviceDefinition.uploadMethods.length === 0) {
                    return store.dispatch({
                        type: 'messages/addMessage',
                        payload: {
                            title: 'Error',
                            message: 'Device does not contain any supported upload methods',
                            cancellable: false,
                        },
                    });
                }
                const files = await debuggerInstance.getCode(project);
                const buildResult = await debuggerInstance.compile(project, files, false);
                if (!buildResult) {
                    store.dispatch({
                        type: 'messages/addMessage',
                        payload: {
                            title: 'Error',
                            message: 'Error compiling project',
                            cancellable: false,
                        },
                    });
                    return;
                }
                if (uploadMethod === 'esp32') {
                    const filesArray = [];
                    let flashAddress = 0x10000;
                    if (deviceDefinition.flashAddress !== undefined) {
                        if (deviceDefinition.flashAddress.startsWith('0x')) {
                            flashAddress = parseInt(deviceDefinition.flashAddress, 16);
                        } else {
                            flashAddress = Number(deviceDefinition.flashAddress);
                        }
                    }
                    filesArray.push({
                        data: buildResult?.binary,
                        address: flashAddress,
                    });
                    if (!debug.connected) {
                        store.dispatch({
                            type: 'debug/setDebugState',
                            payload: DEBUG_STATE.UPLOADING,
                        });
                        try {
                            await debuggerInstance.device.close();
                        } catch (ex) {
                            // ignore
                        }
                        const espLoaderTerminal = {
                            clean() {
                                store.dispatch({
                                    type: 'debug/clearConsole',
                                });
                            },
                            writeLine(data: string) {
                                // term.writeln(data);

                                store.dispatch({
                                    type: 'debug/addToConsole',
                                    payload: `${data}\r\n`,
                                });
                            },
                            write(data: string) {
                                // term.write(data);
                                console.log(data);

                                store.dispatch({
                                    type: 'debug/addToConsole',
                                    payload: data,
                                });
                            },
                        };

                        const esp32Serial = new BrowserESP32Serial(serialPort);
                        await esp32Serial.writeFilesToDevice(filesArray, espLoaderTerminal);
                        await debuggerInstance.device.connect(115200, false);
                        debuggerInstance.addDebugMessage('Upload complete', false, 6000);
                    } else {
                        debuggerInstance.tpc = buildResult.binary;
                        debuggerInstance.startUpload(buildResult.binary, device.mac, !releaseBuild, 'esp32', filesArray, debug.device.baudRate);
                    }
                } else if (uploadMethod === 'bossac') {
                    if (buildResult === undefined) {
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                title: 'Error',
                                message: 'Error compiling project',
                                cancellable: false,
                            },
                        });
                        return;
                    }
                    debuggerInstance.tpc = buildResult.binary;
                    debuggerInstance.startUpload(buildResult.binary, device.mac, false, 'bossac');
                } else if (uploadMethod === 'openocd') {
                    if (buildResult === undefined) {
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                title: 'Error',
                                message: 'Error compiling project',
                                cancellable: false,
                            },
                        });
                        return;
                    }
                    debuggerInstance.tpc = buildResult.binary;
                    debuggerInstance.startUpload(buildResult.symbols, '', false, 'openocd');
                } else if (uploadMethod === 'jlink') {
                    if (buildResult === undefined) {
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                title: 'Error',
                                message: 'Error compiling project',
                                cancellable: false,
                            },
                        });
                        return;
                    }
                    debuggerInstance.tpc = buildResult.binary;
                    debuggerInstance.startUpload(buildResult.binary, '', false, 'jlink');
                } else if (uploadMethod === 'teensy') {
                    if (buildResult === undefined) {
                        store.dispatch({
                            type: 'messages/addMessage',
                            payload: {
                                title: 'Error',
                                message: 'Error compiling project',
                                cancellable: false,
                            },
                        });
                        return;
                    }
                    debuggerInstance.tpc = buildResult.hex;
                    debuggerInstance.startUpload(buildResult.hex, '', false, 'teensy');
                } else {
                    store.dispatch({
                        type: 'messages/addMessage',
                        payload: {
                            title: 'Error',
                            message: 'Device does not contain any supported upload methods',
                            cancellable: false,
                        },
                    });
                    return;
                }
                debuggerInstance.debugging = true;
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.DEBUG,
                });
                store.dispatch({
                    type: 'pages/setShowBottomPanel',
                    payload: true,
                });
                return;
            }
        }
        store.dispatch({
            type: 'pages/setShowBottomPanel',
            payload: true,
        });
        store.dispatch({
            type: 'pages/setShowDeviceExplorer',
            payload: false,
        });
        store.dispatch({
            type: 'pages/setPageFeature',
            payload: {
                page: 'appblocks',
                selectedFeature: undefined,
            },
        });

        await debuggerInstance.handleDebug(device, projectInstance);
        if (device.streamURL) {
            store.dispatch({
                type: 'pages/setCurrentStep',
                payload: 3, // live view page
            });
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDeviceBuzz,
    effect: async (action, store) => {
        debuggerInstance.handleBuzz(action.payload);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDeviceReboot,
    effect: async (action, store) => {
        debuggerInstance.handleReboot(action.payload);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerRefresh,
    effect: async (action, store) => {
        debuggerInstance.refresh();
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDevicePause,
    effect: async (action, store) => {
        debuggerInstance.sendPause();
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerVariablesGetAll,
    effect: async (action, store) => {
        debuggerInstance.getVariables();
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerVariableGet,
    effect: async (action, store) => {
        debuggerInstance.getVariable(action.payload);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerVariableSet,
    effect: async (action, store) => {
        debuggerInstance.setVariable(action.payload.name, action.payload.value);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerStop,
    effect: async (action, store: any) => {
        const { debugState } = store.getState().debug;
        switch (debugState) {
            case DEBUG_STATE.DEBUG:
            case DEBUG_STATE.UPLOADING:
                debuggerInstance.sendStop();
                if (debuggerInstance.simulator) {
                    debuggerInstance.simulator.terminate();
                    debuggerInstance.simulator = undefined;
                }
                break;
            case DEBUG_STATE.BUILDING:
                for (let i = 0; i < debuggerInstance.tasks.length; i++) {
                    if (debuggerInstance.tasks[i].type === DebuggerTaskType.COMPILE) {
                        await axiosInstance.delete(`${process.env.API_URL}/api/tasks/${debuggerInstance.tasks[i].id}`);
                        debuggerInstance.removeTask(debuggerInstance.tasks[i].id);
                        break;
                    }
                }
                break;
            default:
                debuggerInstance.sendStop();
                break;
        }
        store.dispatch({
            type: 'debug/setDebugState',
            payload: DEBUG_STATE.EMPTY,
        });
        store.dispatch({
            type: 'debug/setCurrentBlockBreakpoint',
            payload: undefined,
        });
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDevicePause,
    effect: async (action, store) => {
        debuggerInstance.sendPause();
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDeviceRestartDebug,
    effect: async (action, store: any) => {
        const { device } = store.getState().debug;
        await debuggerInstance.sendStop();
        const project = action.payload;
        const projectInstance = ProjectConfiguration.fromJson(project);
        await debuggerInstance.handleDebug(device, projectInstance);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDeviceLogin,
    effect: async (action, store) => {
        debuggerInstance.deviceLogin(action.payload.mac, action.payload.password);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerSetPassword,
    effect: async (action, store) => {
        debuggerInstance.setPassword(
            action.payload.mac,
            action.payload.oldPassword,
            action.payload.newPassword,
        );
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerUploadApplication,
    effect: async (action, store) => {
        const file = base64ToBin(action.payload.binary);
        debuggerInstance.startUpload(file, action.payload.mac, false);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerUploadFirmware,
    effect: async (action, store) => {
        const file = base64ToBin(action.payload.binary);
        debuggerInstance.handleFirmwareUpload(file, action.payload.mac);
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerTaskStop,
    effect: async (action, store) => {
        for (let i = 0; i < debuggerInstance.tasks.length; i++) {
            if (debuggerInstance.tasks[i].id === action.payload) {
                const task = debuggerInstance.tasks[i];
                switch (task.type) {
                    case DebuggerTaskType.COMPILE:
                        await axiosInstance.delete(`${process.env.API_URL}/api/tasks/${action.payload}`);
                        break;
                    case DebuggerTaskType.UPLOAD_APPLICATION:
                    case DebuggerTaskType.UPLOAD_FIRMWARE:
                        debuggerInstance.sendPCommand(task.data.device.mac, PCODE_COMMANDS.PAUSE);
                        break;
                    default:

                        break;
                }
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
                debuggerInstance.removeTask(action.payload);
                break;
            }
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDownloadRelease,
    effect: async (action, store: any) => {
        const project = action.payload;
        const files = await debuggerInstance.getCode(project);
        store.dispatch({
            type: 'project/setProjectCode',
            payload: files,
        });
        let versionCode;
        for (let i = 0; i < project.features.length; i++) {
            if (project.features[i].id === 'general') {
                versionCode = project.features[i].settings.FIRMWAREVERSION;
                break;
            }
        }
        try {
            let fileExtension = '.tpc';
            if (project.runtime === 'zephyr') {
                fileExtension = '.bin';
            }
            const fileName = `${project.name.replace(/\W/g, '_')}__${versionCode}${fileExtension}`;
            const buildResult = await debuggerInstance.compile(project, files, false);
            if (buildResult === undefined) {
                throw new Error('Compilation Error');
            }
            const buf = Buffer.from(buildResult.binary);
            const blob = new Blob([buf], {
                type: 'application/octet-stream',
            });
            saveAs(blob, fileName);
        } catch (ex) {
            debuggerInstance.addDebugMessage('Compilation Error', false, 3000);
        } finally {
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
        }
    },
});


debugMiddleware.startListening({
    actionCreator: debuggerDownloadTcu,
    effect: async (action, store: any) => {
        const project = action.payload;
        try {
            const tcuBlob = await debuggerInstance.generateTcu(project);
            saveAs(tcuBlob, `${project.name}.tcu`);
        } catch (ex) {
            console.log(ex);
            debuggerInstance.addDebugMessage('Compilation Error', false, 3000);
        } finally {
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerSaveFirmware,
    effect: async (action, store: any) => {
        try {
            store.dispatch({
                type: 'messages/clearMessages',
            });
            const buf = Buffer.from(action.payload);
            const blob = new Blob([buf], {
                type: 'application/octet-stream',
            });
            await saveFile(blob, 'zephyr.hex');
            store.dispatch({
                type: 'pages/setShowBottomPanel',
                payload: true,
            });
        } catch (ex) {
            console.log(ex);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerSaveTcu,
    effect: async (action, store: any) => {
        return new Promise(async (resolve, reject) => {
            const {
                sourceProject, versionCode, name, project,
            } = action.payload;
            try {
                let fileExtension = '.tcu';
                let firmwareBinary: any;
                if (project.runtime === 'tios') {
                    firmwareBinary = await debuggerInstance.generateTcu(project);
                } else if (project.runtime === 'zephyr') {
                    fileExtension = '.bin';
                    const files = await debuggerInstance.getCode(project);
                    const buildResult = await debuggerInstance.compile(project, files, false);
                    const tcuBuf = Buffer.from(buildResult?.binary, 'base64');
                    firmwareBinary = new Blob([tcuBuf], {
                        type: 'application/octet-stream',
                    });
                }
                const device = PlatformUtils.getDevice(project.device);
                const firmwareVersion = `${project.device}-${device.firmwareVersion}`;

                const formData = new FormData();
                formData.append('name', `${name}`);
                formData.append('binary', firmwareBinary, `${sourceProject}_${versionCode}_${firmwareVersion}${fileExtension}`);
                formData.append('runtime', project.runtime);
                formData.append('firmwareVersion', firmwareVersion);


                // Send the FormData with Axios
                const res = await axiosInstance.put(`${process.env.API_URL}/api/projects/${sourceProject}/versions/${versionCode}`, formData);
                if (res.status === 204) {
                    debuggerInstance.addDebugMessage('Snapshot Saved', false, 3000);
                    store.dispatch({
                        type: 'debug/setFirmwareUploadState',
                        payload: FIRMWARE_UPLOAD_STATE.SAVED,
                    });
                }
                resolve();
            } catch (ex) {
                console.log(ex);
                debuggerInstance.addDebugMessage('Error uploading firmware', false, 3000);
                store.dispatch({
                    type: 'debug/setFirmwareUploadState',
                    payload: FIRMWARE_UPLOAD_STATE.ERROR,
                });
                reject(ex);
            } finally {
                store.dispatch({
                    type: 'debug/setDebugState',
                    payload: DEBUG_STATE.EMPTY,
                });
            }
        });
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDownloadTcuFromServer,
    effect: async (action, store: any) => {
        const { _id, name } = action.payload;
        const res = await axiosInstance.get(`${process.env.API_URL}/cgg/firmware/download/${_id}`, { responseType: 'arraybuffer' });
        const blob = new Blob([res.data], {
            type: 'application/octet-stream',
        });
        saveAs(blob, `${name}.tcu`);
    },
});


debugMiddleware.startListening({
    actionCreator: debuggerUploadRelease,
    effect: async (action, store: any) => {
        const project = action.payload;
        const files = await debuggerInstance.getCode(project);
        const { device } = store.getState().debug;

        try {
            const buildResult = await debuggerInstance.compile(project, files, false);
            store.dispatch({
                type: 'debug/setDebugState',
                payload: DEBUG_STATE.EMPTY,
            });
            debuggerInstance.startUpload(buildResult.binary, device.mac, false);
        } catch (ex) {
            debuggerInstance.addDebugMessage('Compilation Error', false, 3000);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: deviceDashboardProxyHttpRequest,
    effect: async (action, store: any) => {
        const {
            url,
            data,
            method,
            headers,
            nonce,
        } = action.payload;
        const request: HTTPMessage = {
            url,
            data,
            method,
            headers,
            nonce,
        };
        store.dispatch({
            type: 'debug/setDeviceDashboardRequests',
            payload: {
                ...request,
                data: null,
            },
        });
        debuggerInstance.httpRequest(request);
    },
});

debugMiddleware.startListening({
    actionCreator: toggleBlockBreakpoint,
    effect: async (action, store: any) => {
        debuggerInstance.setBreakpoints();
    },
});

debugMiddleware.startListening({
    actionCreator: setProjectCode,
    effect: async (action, store: any) => {
        debuggerInstance.setBreakpoints();
    },
});

debugMiddleware.startListening({
    actionCreator: setGPIOState,
    effect: async (action, store: any) => {
        const { address, pin, state } = action.payload;
        debuggerInstance.setGPIOState(address, pin, state);
    },
});

debugMiddleware.startListening({
    actionCreator: sendWiegand,
    effect: async (action, store: any) => {
        const { address, value } = action.payload;
        debuggerInstance.sendWiegand(address, value);
    },
});


debugMiddleware.startListening({
    actionCreator: debuggerAttachSerial,
    effect: async (action, store: any) => {
        try {
            const { device: storeDevice, connected, selectedNetwork } = store.getState().debug;
            const browser = !(connected && selectedNetwork === 'localhost');
            if (!browser) {
                debuggerInstance.debugStarted = true;
                const reset = action.payload.reset || false;
                const message = {
                    port: storeDevice.mac,
                    baudRate: action.payload.baudRate,
                    reset,
                };
                debuggerInstance.socket.emit('attach_serial', message);
                store.dispatch({
                    type: 'debug/debuggerSetSerialPort',
                    payload: {
                        port: storeDevice.mac,
                    },
                });
                return;
            }
            let device = debuggerInstance.device;
            let port;
            if (device) {
                port = await device.maybeGetPort();
            } else {
                device = new SerialPort();
                await device.connect(action.payload.baudRate);
                debuggerInstance.device = device;
                port = await device.getPort();
            }
            store.dispatch({
                type: 'debug/debuggerSetSerialPort',
                payload: {
                    port: 'COM',
                },
            });

            device.on('data', (data: any) => {
                const text = new TextDecoder().decode(data);
                store.dispatch({
                    type: 'debug/addToConsole',
                    payload: text,
                });
            });
        } catch (ex) {
            store.dispatch({
                type: 'debug/debuggerDetachSerial',
            });
            console.log(ex);
        }
    },
});

debugMiddleware.startListening({
    actionCreator: debuggerDetachSerial,
    effect: async (action, store: any) => {
        try {
            const { device: storeDevice, connected, selectedNetwork } = store.getState().debug;
            const browser = !(connected && selectedNetwork === 'localhost');
            if (!browser) {
                debuggerInstance.debugStarted = false;
                if (storeDevice) {
                    const message = {
                        port: storeDevice.mac,
                    };
                    debuggerInstance.socket.emit('detach_serial', message);
                }
                return;
            }
            if (debuggerInstance.device) {
                await debuggerInstance.device.disconnect();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            debuggerInstance.device = undefined;
        }
    },
});

debugMiddleware.startListening({
    actionCreator: simulatorSendEvent,
    effect: async (action, store: any) => {
        /**
         {"type": "action_type",}
         */
        try {
            if (debuggerInstance.simulator) {
                debuggerInstance.simulator.postMessage(action.payload);
            }
        } catch (ex) {
            console.log(ex);
        }
    },
});

const saveFile = async (blob, suggestedName) => {
    // Feature detection. The API needs to be supported
    // and the app not run in an iframe.
    const supportsFileSystemAccess =
        'showSaveFilePicker' in window &&
        (() => {
            try {
                return window.self === window.top;
            } catch {
                return false;
            }
        })();
    // If the File System Access API is supported…
    if (supportsFileSystemAccess) {
        try {
            // Show the file save dialog.
            const handle = await showSaveFilePicker({
                suggestedName,
            });
            // Write the blob to the file.
            const writable = await handle.createWritable();
            await writable.write(blob);
            await writable.close();
            return;
        } catch (err) {
            // Fail silently if the user has simply canceled the dialog.
            if (err.name !== 'AbortError') {
                console.error(err.name, err.message);
                return;
            }
        }
    }
    // Fallback if the File System Access API is not supported…
    // Create the blob URL.
    const blobURL = URL.createObjectURL(blob);
    // Create the `<a download>` element and append it invisibly.
    const a = document.createElement('a');
    a.href = blobURL;
    a.download = suggestedName;
    a.style.display = 'none';
    document.body.append(a);
    // Programmatically click the element.
    a.click();
    // Revoke the blob URL and remove the element.
    setTimeout(() => {
        URL.revokeObjectURL(blobURL);
        a.remove();
    }, 1000);
};


// function loadHex(source: string, target: Uint8Array) {
//     for (const line of source.split('\n')) {
//         if (line[0] === ':' && line.substr(7, 2) === '00') {
//             const bytes = parseInt(line.substr(1, 2), 16);
//             const addr = parseInt(line.substr(3, 4), 16);
//             for (let i = 0; i < bytes; i++) {
//                 target[addr + i] = parseInt(line.substr(9 + i * 2, 2), 16);
//             }
//         }
//     }
// }


export default debugMiddleware;
